<template>
  <v-container>
    <v-dialog v-model="dialog" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Loading maintenance state...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-layout row>
      <span class="headline pt-1 mb-3">Testing page</span>
    </v-layout>
    <v-divider></v-divider>

    <v-divider></v-divider>
    <v-layout row justify-center mt-4>
      <v-btn @click="throwError">Throw error Sentry</v-btn>
    </v-layout>
    <v-layout row justify-center mt-4>
      <v-flex xs10>
        <v-layout row class="mt-2">
          <v-flex xs12>
            <v-card class="mb-2">
              <v-layout row class="my-3 ml-2">
                <v-flex xs12>
                  <h4 class="my-2">Manual Drop Lifecycle Functions</h4>
                </v-flex>
              </v-layout>
              <v-layout row class="my-3 my-2 ml-3 pb-4 mr-2">
                <v-flex xs12>
                  <p>Select date at which you want to run the function (check in executed_drops or scheduled_drops firestore collection for correct date):</p>
                  <v-menu max-width="290">
                    <template v-slot:activator="{ on }">
                      <v-text-field :value="executionDate" label="Start Date" readonly v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="executionDate"></v-date-picker>
                  </v-menu>
                  <div class="d-flex flex-column">
                    <v-btn class="my-2" @click="startAutomatedDropExecution">
                      <span>Start Automated Drop Execution</span>
                    </v-btn>
                    <v-btn class="my-2" @click="sendDropsToOsprey">
                      <span>Send Drops To Osprey</span>
                    </v-btn>
                  </div>
                </v-flex>
              </v-layout>
              <drops-reschedule-tool/>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row class="mt-2">
          <v-flex xs12>
            <v-card class="mb-2">
              <v-layout row class="my-3 ml-2 mt-2">
                <v-flex xs12>
                  <h4 class="mx-3 mt-2">Test generating Quote - PDF</h4>
                </v-flex>
              </v-layout>
              <v-layout row class="my-3 my-2 ml-2">
                <v-flex xs12>
                  <v-btn class="static" @click="testQuotePDF()">
                    <span>PDF</span>
                  </v-btn>
                  <v-row class="mx-1">
                    <v-col cols="12" sm="12">
                      <h4 class="ml-3 my-2">Json Example:</h4>
                      <v-expansion-panels>
                        <v-expansion-panel v-for="(item, i) in 1" :key="i">
                          <v-expansion-panel-header class="mx-0">Json</v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <vue-json-pretty :data="json" :show-double-quotes="true" :show-length="true" :show-line="true"> </vue-json-pretty>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-col>
                  </v-row>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row class="mt-2">
          <v-flex xs12>
            <v-card class="mb-2">
              <v-layout row class="my-3 ml-2">
                <v-flex xs12>
                  <h4 class="mx-3 mt-3">Test new notification</h4>
                </v-flex>
              </v-layout>
              <v-layout row class="my-3 my-2 ml-2">
                <v-flex xs6>
                  <v-btn class="static mb-3" @click="testAddNotification()">
                    <span>add notification</span>
                  </v-btn>
                </v-flex>
                <v-flex xs6>
                  <div class="mb-2 mr-1">
                    <v-alert v-model="notificationAdded" type="success" dismissible> Notification added! </v-alert>
                  </div>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row class="mt-2">
          <v-flex xs12>
            <v-alert v-model="alertSuccesAdd" type="success" dismissible outlined>
              New <strong> {{ envType }}</strong> successfully added to DB! ID: {{ envId }}
            </v-alert>
            <v-card class="mb-4">
              <v-layout row class="my-3 ml-2">
                <v-flex xs12>
                  <h4 class="mx-3 mt-3">Add new (test) order/map/list/design</h4>
                </v-flex>
              </v-layout>
              <v-layout row class="my-3 my-2 ml-2">
                <v-flex xs6 sm6>
                  <v-autocomplete v-model="selectedSite" :items="sites" label="Sites" chips item-value="firebase_id" item-text="site_id"></v-autocomplete>
                  <v-autocomplete v-model="selectedEnv" :items="envs" label="envs" chips item-value="name" item-text="name"></v-autocomplete>
                  <v-btn class="static my-2" @click="addOrder()">
                    <span>Add</span>
                  </v-btn>
                </v-flex>
                <v-flex xs6>
                  <div class="mx-3 custom-border">
                    <h3 class="red--text">Warning</h3>
                    <p>Use test sites! By adding new items on the live sites , the items will appear on live site also.</p>
                  </div>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row class="mt-2">
          <v-flex xs12>
            <v-card class="mb-2">
              <v-progress-linear v-if="generateExcell" :indeterminate="generateExcell" class="my-0"></v-progress-linear>
              <v-layout row class="my-3 ml-2">
                <v-flex xs12>
                  <h4 class="mx-3 my-2 mt-2">Test generating CSV file based on data from Data-axle</h4>
                </v-flex>
              </v-layout>
              <v-layout row class="my-3 my-2 ml-2">
                <v-flex xs4>
                  <v-btn class="static mb-2" @click="generateExcel()">
                    <span>Generate Excell</span>
                  </v-btn>
                </v-flex>
                <v-flex xs8>
                  <div class="mb-2 mr-1">
                    <h4 class="ml-3 my-2">Filters:</h4>
                    <v-expansion-panels class="mb-2">
                      <v-expansion-panel v-for="(item, i) in 1" :key="i">
                        <v-expansion-panel-header>Filter JSON</v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-card>
                            <vue-json-pretty :data="excelFilters" :show-double-quotes="true" :show-length="true" :show-line="true"> </vue-json-pretty>
                          </v-card>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </div>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row class="mt-2">
          <v-flex xs12>
            <v-card class="mb-2">
              <v-progress-linear v-if="generateExcellPolitical" :indeterminate="generateExcellPolitical" class="my-0"></v-progress-linear>
              <v-layout row class="my-3 ml-2">
                <v-flex xs12>
                  <h4 class="mx-3 my-2 mt-2">Test generating CSV file based on data from Political Mail</h4>
                </v-flex>
              </v-layout>
              <v-layout row class="my-3 my-2 ml-2">
                <v-flex xs4>
                  <v-btn class="static mb-2" @click="generateExcelPolitical()">
                    <span>Generate Excell</span>
                  </v-btn>
                </v-flex>
                <v-flex xs8>
                  <div class="mb-2 mr-1">
                    <h4 class="ml-3 my-2">Filters:</h4>
                    <v-expansion-panels class="mb-2">
                      <v-expansion-panel v-for="(item, i) in 1" :key="i">
                        <v-expansion-panel-header>Filter JSON</v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-card>
                            <vue-json-pretty :data="excelFiltersPolitical" :show-double-quotes="true" :show-length="true" :show-line="true"> </vue-json-pretty>
                          </v-card>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </div>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row class="mt-2">
          <v-flex xs12>
            <v-card class="mb-2">
              <v-progress-linear v-if="generateMapObjectProgress" :indeterminate="generateMapObjectProgress" class="my-0"></v-progress-linear>
              <v-layout row class="my-3 ml-2">
                <v-flex xs12>
                  <h4 class="mx-3 my-2">Test Firebase Function that returns map object based in the map firebase id that is send</h4>
                </v-flex>
              </v-layout>
              <v-layout row class="my-3 my-2 ml-3 pb-4">
                <v-flex xs4>
                  <v-text-field v-model="mapFirebaseId" label="Map Firebase Id" type="text"> </v-text-field>
                  <v-btn class="static" @click="generateMapObject()">
                    <span>get map object</span>
                  </v-btn>
                </v-flex>
                <v-flex xs8>
                  <div v-if="mapObjectSuccess" class="mb-2 mx-2">
                    <h4 class="ml-3 my-2">API result</h4>
                    <v-expansion-panels class="my-2 px-1">
                      <v-expansion-panel v-for="(item, i) in 1" :key="i">
                        <v-expansion-panel-header>Response JSON</v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-card>
                            <vue-json-pretty :data="mapObject" :show-double-quotes="true" :show-length="true" :show-line="true"> </vue-json-pretty>
                          </v-card>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </div>
                  <div v-if="errorMsg.length != 0" class="ml-3">
                    <h3 class="red--text">Error:</h3>
                    <p>{{ errorMsg }}</p>
                  </div>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row class="mt-2">
          <v-flex xs12>
            <v-card class="mb-2">
              <v-layout row class="my-3 ml-2">
                <v-flex xs12>
                  <h4 class="mx-3 my-2">Test Dmm Tool</h4>
                </v-flex>
              </v-layout>
              <v-layout row class="my-3 my-2 ml-3 pb-4 mr-2">
                <v-flex xs12>
                  <p>URL(test):</p>
                  <v-textarea v-model="testDmmToolUrl" name="input-7-1" label="URL" :filled="true" height="100"> </v-textarea>
                  <v-btn class="static" @click="launchCampaign()">
                    <span>Launch Campaign</span>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row class="mt-2">
          <v-flex xs12>
            <v-card class="mb-2">
              <v-layout row class="my-3 ml-2">
                <v-flex xs12>
                  <h4 class="mx-3 my-2">Migrate Data to cAMP sites</h4>
                </v-flex>
              </v-layout>
              <v-layout row class="my-3 my-2 ml-3 pb-4 mr-2">
                <v-flex xs12>
                  <p>
                    <v-btn class="static" disabled @click="migrateOrders()">
                      <span>Migrate Orders</span>
                    </v-btn>
                  </p>
                  <br />
                  <!-- Migrate orders, list, maps and payments - using dynamic site db id -->
                  <p>
                    <input v-model="selectedSiteToMigrate" placeholder="Firebase Site ID" style="margin-right: 1em" />
                  </p>
                  <p>
                    <input v-model="firebaseIdListFromFront" placeholder="Firebase ID List" style="margin-right: 1em" />
                  </p>
                  <p>
                    <v-btn class="static" @click="getFirebaseOrderIdsPerSite(selectedSiteToMigrate)">
                      <span>Get Order Data by Site Firebase ID</span><br />
                      <span>(Firebase Order Ids, Order Data, Firebase + CRM order ids, incomplete orders), Product names + Firebase IDs</span>
                    </v-btn>
                  </p>
                  <p>
                    <v-btn class="static" @click="getProductsFromOrderByProductName(selectedSiteToMigrate)">
                      <span>Get Products data from order by Product name based on the site</span><br />
                      <span>(Order Data / Product - prod IDs, Assets)</span>
                    </v-btn>
                  </p>
                  <p>
                    <v-btn class="static" @click="getProductsBySiteFromAPI(selectedSiteToMigrate)">
                      <span>Get Products data By Site ID from API</span>
                    </v-btn>
                  </p>
                  <p>
                    <v-btn class="static" @click="getOrdersRelatedDataIdsBySite(selectedSiteToMigrate)">
                      <span>Get Orders Related Data Ids By Site ID (Maps, Lists, Designs, Payments, Customers)</span>
                    </v-btn>
                  </p>
                  <p>
                    <v-btn class="static" @click="migrateOrdersToGrowmail()">
                      <span>Migrate Orders To Growmail</span>
                    </v-btn>
                  </p>
                  <p>
                    <v-btn class="static" @click="migrateMapsToGrowmail()">
                      <span>Migrate Maps To Growmail</span>
                    </v-btn>
                  </p>
                  <p>
                    <v-btn class="static" @click="migrateListsToGrowmail()">
                      <span>Migrate Lists To Growmail</span>
                    </v-btn>
                  </p>
                  <p>
                    <v-btn class="static" @click="migrateDesignToGrowmail()">
                      <span>Migrate Designs To Growmail</span>
                    </v-btn>
                  </p>
                  <p>
                    <v-btn class="static" @click="migratePaymentsToGrowmail()">
                      <span>Migrate Payments To Growmail</span>
                    </v-btn>
                  </p>
                  <p>
                    <v-btn class="static" @click="migrateCustomersToGrowmail()">
                      <span>Migrate Customers To Growmail</span>
                    </v-btn>
                  </p>
                  <p>
                    <v-btn class="static" @click="createMatchedUsers()">
                      <span>Create Match users</span>
                    </v-btn>
                  </p>
                  <p>
                    <v-btn class="static" @click="convertCsvToJson()">
                      <span>Convert CSV to JSON</span>
                    </v-btn>
                  </p>
                  <p>
                    <v-btn class="static" @click="getDataByFilters()">
                      <span>Get Data By Filters</span>
                    </v-btn>
                  </p>
                  <p>
                    <v-btn class="static" @click="getGMChangedUsers()">
                      <span>Get Changed users</span>
                    </v-btn>
                  </p>
                  <p>
                    <v-btn class="static" @click="getGMSavedDataFromDb()">
                      <span>Get GM orders, maps, users, lists, payments by user</span>
                    </v-btn>
                  </p>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row class="mt-2">
          <v-flex xs12>
            <v-card class="mb-2">
              <v-layout row class="my-3 ml-2">
                <v-flex xs12>
                  <h4 class="mx-3 my-2">Add attributes to order objects root in the Database</h4>
                </v-flex>
              </v-layout>
              <!-- <v-text-field label="Map Firebase Id" v-model="mapFirebaseId" type="text"> -->
              <v-layout row class="my-3 my-2 ml-3 pb-4 mr-2">
                <v-flex xs12>
                  <v-btn class="static" disabled @click="addItemToOrderRoot()">
                    <span>Add Items</span>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row class="mt-2">
          <v-flex xs12>
            <v-card class="mb-2">
              <v-layout row class="my-3 ml-2">
                <v-flex xs12>
                  <h4 class="mx-3 my-2">Save Test Customer To DB (customers collextion)</h4>
                </v-flex>
              </v-layout>
              <v-layout row class="my-3 my-2 ml-3 pb-4 mr-2">
                <v-flex xs12>
                  <v-btn class="static" disabled @click="saveTestCustomer()">
                    <span>Save</span>
                  </v-btn>
                  <v-btn class="static" disabled @click="saveAllCustomers()">
                    <span>Save Customers To Algolia</span>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { auth, dbFS } from '../../services/firebaseInit';
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';
import moment from 'moment';
import { mapGetters } from 'vuex';
import RestClient from '../../modules/rest-client.js';
import algoliasearch from 'algoliasearch';
import siteSettingsService from '../../services/siteSettingsService';
import { cloudFunctionsPost } from '../../modules/cloud-function-wrapper.js';
import DropsRescheduleTool from '../order-management/tools/DropsRescheduleTool.vue';

export default {
  components: {
    VueJsonPretty,
    'drops-reschedule-tool':DropsRescheduleTool,
  },
  data() {
    return {
      dialog: false,
      created: false,
      executionDate: moment().format('YYYY-MM-DD'),
      testDmmToolUrl:
        process.env.VUE_APP_APP_URL +
        'dmm-tool/?firestore_map_id=K83GQUBAUFi33mkIoB2u&start_date=2019-08-21&end_date=2019-09-20&crm_order_id=284144&drop_num=342&crm_mail_drop_id=1234&dmm_campaign_id=110777',
      json: {
        crm_order_id: 0,
        order_label: 'Test Targeted Order - Do not process (Kincso)',
        client_logo: '',
        creation_date: 'May 2, 2019',
        order_type: 'targeted',
        extra_qty: 0,
        mail_qty: 3100,
        total_qty: 3100,
        map_name: 'Map name example TEST',
        map_image: `${process.env.VUE_APP_FIREBASE_STORAGE_URL}wlos-1%2F61063-3%2Fmap%2F06-19-2019%2Fmap_1560977013882.png?alt=media&token=c1d6eb44-b89c-463f-9e1c-54271c777ef1`,
        product_name: '6.25×9 Standard EDDM',
        artwork_type: 'Artwork From Previous Order',
        gatekeeper_email: '',
        stock_type: '14pt C2S',
        coating_type: 'Standard',
        special_instructions: '',
        shipping_address: {
          label: 'Address for testing',
          apartment: '204',
          street: '400 Spruce St ',
          city: 'Tarpon Springs',
          state: 'FL',
          zip_code: '34689'
        },
        shipping_method_name: '',
        delivery: {
          delivery_dates: [
            {
              date: '',
              qty: 0
            }
          ],
          delivery_times: '1 time(s) / month',
          delivery_extend: 'Start with earlier month',
          delivery_months: 'Nov, Oct, Apr, Mar'
        },
        purchased_list_filters: {},
        pricing: {
          order_total: '1,254.83',
          base_price: '211.83',
          postage: 1199.0,
          mailing_service_fee: '129.17',
          total_per_piece: '0.40',
          list_purchase: 0,
          list_processing: 0,
          digital_price: 0,
          landing_page: 0,
          eddm_shipping_price: 0,
          extra_qty_price: '0.00',
          shipping_extra_price: '0.00',
          shipping: 0,
          tax_price: '14.83',
          stock_price: '0.00',
          coating_price: '0.00',
          design_price: '0.00',
          turnaround_price: '0.00'
        },
        digital_campaign: {
          name: 'test',
          qty: 0,
          price: 0
        },
        suppression_lists: ['1572946339331_mailinglist_big_not_ok'],
        artwork_uploaded_files: ['1572946377695_Screenshot 2018-10-26 at 16.26.11.png', '1572946377693_Screenshot 2018-10-26 at 14.48.42.png'],
        userDefinedOrderFields: {
          switch_1: {
            label: 'Grand Opening: Include in reporting for campaigns supporting the opening of a denovo location.',
            value: 'ON'
          },
          switch_2: {
            label: 'Label2',
            value: 'ON'
          },
          switch_3: {
            label: 'Label33',
            value: 'OFF'
          },
          switch_4: {
            label: 'Label4',
            value: 'OFF'
          },
          field_1: {
            label: 'Internal ID',
            value: 'epicore1'
          },
          field_2: {
            label: 'Label 1',
            value: 'test1'
          },
          field_3: {
            label: 'Label 2: -',
            value: '-'
          },
          field_4: {
            label: 'Label 3',
            value: 'test3'
          },
          field_5: {
            label: 'Label 4',
            value: 'test4'
          }
        }
      },
      excelFilters: {
        filter: {
          connective: 'and',
          propositions: [
            {
              relation: 'equals',
              attribute: 'zip',
              value: '34689'
            },
            {
              relation: 'equals',
              attribute: 'family.behaviors',
              value: 'gaming'
            },
            {
              relation: 'equals',
              attribute: 'family.home_owner',
              value: true
            }
          ]
        }
      },
      excelFiltersPolitical: {
        filters: {
          '2011_NEW_Congressional_District': ['02'],
          Parties_Description: ['Republican'],
          Voters_AgeRange: ['18 to 29'],
          EthnicGroups_EthnicGroup1Desc: ['European'],
          Voters_Gender: ['M'],
          Education: ['Bach Degree - Likely'],
          HomeOwnerRenter: ['Likely Homeowner'],
          EstimatedIncome: ['$1,000-$14,999', '$15,000-$24,999', '$25,000-$34,999']
        },
        fieldset: 'minimal'
      },
      notificationAdded: false,
      responseData: '',
      selectedEnv: null,
      envs: [{ name: 'orders' }, { name: 'maps' }, { name: 'lists' }, { name: 'designs' }],
      sites: [],
      selectedSite: null,
      alertSuccesAdd: false,
      envType: '',
      envId: '',
      generateExcell: false,
      generateExcellPolitical: false,
      mapFirebaseId: '',
      generateMapObjectProgress: false,
      mapObjectSuccess: false,
      mapObject: {},
      errorMsg: '',
      apiKey: process.env.VUE_APP_MAP_OBJ_BY_FIREBASE_ID_TKN,
      url: process.env.VUE_APP_APP_URL,
      genTkn: process.env.VUE_APP_GENERAL_TKN,
      selectedSiteToMigrate: '',
      firebaseIdListFromFront: ''
    };
  },
  computed: {
    ...mapGetters('user', {
      userStore: 'user'
    })
  },
  watch: {
    selectedSite(value) {
      console.log('selected value', value);
    }
  },
  async created() {
    console.log('Created');
    this.sites = await siteSettingsService.getAll({ isArray: true });
  },
  methods: {
    throwError() {
      throw new Error('Sentry Error');
    },
    //Save Test Customer object to database
    /* eslint-disable no-mixed-spaces-and-tabs */
    saveTestCustomer() {
      const config = {
        address: '',
        email: 'kincsok@onebrandmarketing.com',
        first_name: 'Kincso',
        last_name: 'Kiss',
        company: 'Test company',
        brand_id: 1,
        crm_customer_id: 123456,
        customer_unique_id: 'test_1',
        firebase_site_id: 'test',
        site_id: 'test',
        wp_user_id: 2,
        stripe_customer: '',
        stripe_test_customer: '',
        phone: ''
      };
      console.log('Create customer: ', config);
      dbFS.collection('customers').doc().set(config);
    },
    saveAllCustomers() {
      //Save all customer to Algolia from customers collection
      const searchClient = algoliasearch(process.env.VUE_APP_ALGOLIA_APP_ID, process.env.VUE_APP_ALGOLIA_API_KEY);
      const algoliaIndex = searchClient.initIndex('customers');
      return dbFS
        .collection('customers')
        .get()
        .then(data => {
          console.log('LoadCustomer: ', data);
          const customerObjects = [];
          let algoliaCustomer = '';
          let customer = '';

          data.forEach(doc => {
            if (doc.exists) {
              customer = doc.data();
              algoliaCustomer = Object.assign({}, customer);
              algoliaCustomer.firebase_customer_id = doc.id;
              algoliaCustomer.creationDateTimestamp = parseInt(this.$moment(customer.created_at).unix());

              console.log('algoliaCustomer: ', algoliaCustomer);
              console.log('algoliaIndex: ', algoliaIndex);
              customerObjects.push(algoliaCustomer);
            }
          });

          console.log('customerObjects: ', customerObjects);

          return Promise.all([algoliaIndex.addObjects(customerObjects)])
            .then(result => {
              console.log('Saving the customer into Algolia has succeeded: ', result);
              return Promise.resolve();
            })
            .catch(err => {
              console.log(`Saving the customer into the Algolia has failed: ${err}`);
              return Promise.reject();
            });
        })
        .catch(err => {
          console.log(`Load customers has failed: ${err}`);
          return Promise.reject();
        });
    },

    getSiteSettingsBySiteId(selectedSiteId) {
      return dbFS
        .collection('sites')
        .doc(selectedSiteId)
        .get()
        .then(snapshot => {
          return snapshot.data();
        });
    },

    async getProductsBySiteFromAPI(site, products) {
      const growMailSite = await this.getSiteSettingsBySiteId('-Ls27CixwWnltalW_ae_');
      const growMailProducts = this.getProducts();
      const siteSettings = site || growMailSite;
      const productList = products?.length ? products : growMailProducts;
      const productResult = [];
      // Get Growmail products from API:
      this.$store.commit('setSiteForQuoteTool', siteSettings.site_url);
      const restClient = new RestClient('products', this.$store);
      const productPromises = [];

      // Get JWT Auth token to use API endpoints
      return restClient.apiAuth(siteSettings).then(authToken => {
        const HTTP = this.axios.create({
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: authToken
          }
        });
        // Get the Growmail products data
        for (let product of productList) {
          productPromises.push(HTTP.get(`${siteSettings.site_url}products/${product.id || product.ID}`));
        }

        return Promise.all(productPromises).then(result => {
          for (let i in result) {
            productResult.push({ product: result[i].data?.product });
          }
          console.log(`[getProductsBySiteFromAPI] Result:`);
          console.log(productResult);
          return productResult;
        });
      });
    },

    async startAutomatedDropExecution() {
      cloudFunctionsPost('/startAutomatedDropExecution', { date: this.executionDate }).then(result => {
        console.log('startAutomatedDropExecution result: ', result?.data || result);
      });
    },

    async sendDropsToOsprey() {
      cloudFunctionsPost('/sendDropsToOsprey', { date: this.executionDate }).then(result => {
        console.log('sendDropsToOsprey result: ', result?.data || result);
      });
    },

    getProducts() {
      const growmailProductsFile = require('@/assets/migration/growmail_products_2022.json');
      // const growmailProductsFile = require('@/assets/migration/growmail_products.json');
      console.log('Growmail Products: ', growmailProductsFile.products);
      return growmailProductsFile.products;
    },

    getProductsDataFromApi() {
      const growmailProductsDataFile = require('@/assets/migration/growmail_products_data_from_api_2022.json');
      // const growmailProductsDataFile = require('@/assets/migration/growmail_products_data_from_api.json');
      // OR USE this.getProductsBySiteFromAPI(growmailSiteSettings, growmailProducts) to get data from API
      console.log('Growmail Products Data From API: ', growmailProductsDataFile.productsData);
      return growmailProductsDataFile.productsData;
    },

    getUsersFromDestinationSite() {
      const growmailUsersFile = require('@/assets/migration/growmail_all_users_legacy_2022.json');
      console.log('Growmail Users: ', growmailUsersFile.users);
      return growmailUsersFile.users;
    },

    getUsersLocationsFromDestinationSite() {
      const growmailLocationsFile = require('@/assets/migration/growmail_all_locations_2022.json');
      console.log('Growmail Locations: ', growmailLocationsFile.locations);
      return growmailLocationsFile.locations;
    },

    getProductDataByName(growmailProducts, productsData, currentProductName, internalProdID) {
      // Note: Make sure the order contains internal_product_id
      // internal_product_id should be the same on all of the sites
      const campProduct = growmailProducts.find(
        item =>
          item['Internal Product ID'].toString() === internalProdID ||
          item.Title === currentProductName ||
          (currentProductName.includes('CUSTOM') && item.Title.includes(`Custom ${currentProductName.split('CUSTOM ')[1]}`))
      );
      const growmailProdId = campProduct?.id || '';
      const growmailProdData = productsData.find(item => item.data?.product?.product_id === growmailProdId || item.product.product_id === growmailProdId);
      return growmailProdData?.data?.product || growmailProdData?.product || '';
    },

    getMatchedUser(currentCustomerEmail, campUsers) {
      const formattedEmail = currentCustomerEmail.toLowerCase();
      const user = campUsers.find(item => item.email.toLowerCase() === formattedEmail);
      return user && Object.keys(user).length ? user : '';
    },
    // Get the GM users whos wp_user_id had been changed
    getGMChangedUsers() {
      const growmailUsers = this.getUsersFromDestinationSite();

      const resultSameID = [];
      const resultDiffID = [];

      for (let i in growmailUsers) {
        if (
          !growmailUsers[i].wp_id_legacy_imagemedia &&
          !growmailUsers[i].wp_id_legacy_sonicprint &&
          !growmailUsers[i].wp_id_legacy_onebrandcamp &&
          growmailUsers[i].wp_id_legacy_growmail
        ) {
          if (growmailUsers[i].wp_id_legacy_growmail !== growmailUsers[i].wp_user_id) {
            resultDiffID.push({
              email: growmailUsers[i].email,
              crm_customer_id: growmailUsers[i].crm_customer_id,
              wp_user_id: growmailUsers[i].wp_user_id
            });
          } else {
            resultSameID.push({
              email: growmailUsers[i].email,
              crm_customer_id: growmailUsers[i].crm_customer_id,
              wp_user_id: growmailUsers[i].wp_user_id
            });
          }
        }
      }

      console.log('resultSameID: ', resultSameID);
      console.log('resultDiffID: ', resultDiffID);
    },
    // Get GM user's data based on email or wp_user_id
    // It's possible the GM user's wp_user_id is changed during the migration
    getGMSavedDataFromDb() {
      const promises = [];
      const growmailUsers = require('@/assets/migration/growmail_updated_users_2022.json');
      const users = growmailUsers.users;

      const orderList = {};
      const orderListArray = [];
      let orderDoc = '';

      const maps = [];
      const lists = [];
      const designs = [];
      const customers = [];
      let payments = [];

      const ordersID = [];

      for (let i in ordersID) {
        promises.push(
          dbFS
            .collection('orders')
            .doc(ordersID[i])
            .get()
            .then(order => {
              if (order.exists) {
                orderDoc = order.data();
                if (orderDoc.payments.length) {
                  payments = payments.concat(orderDoc.payments);
                }
              }

              return;
            })
        );
      }
      for (let i in users) {
        if (users[i].wp_id_legacy_growmail) {
          promises.push(
            dbFS
              .collection('payments')
              .where('site_db_id', '==', '-Ls27CixwWnltalW_ae_')
              .get()
              .then(paymentData => {
                paymentData.forEach(async paymentDoc => {
                  if (paymentDoc.exists) {
                    lists.push(paymentDoc.id);
                  }
                });
                return;
              })
          );
        }

        promises.push(
          dbFS
            .collection('maps')
            .where('customer.email', '==', users[i].email)
            .get()
            .then(mapsData => {
              mapsData.forEach(async mapDoc => {
                if (mapDoc.exists) {
                  maps.push(mapDoc.id);
                }
              });
              return;
            })
        );
        // LIST
        promises.push(
          dbFS
            .collection('mailingLists')
            .where('customer.userEmail', '==', users[i].email)
            .get()
            .then(listsData => {
              listsData.forEach(async listDoc => {
                if (listDoc.exists) {
                  lists.push(listDoc.id);
                }
              });
              return;
            })
        );
        // DESIGN
        promises.push(
          dbFS
            .collection('customDesigns')
            .where('customer.userEmail', '==', users[i].email)
            .get()
            .then(designsData => {
              designsData.forEach(async designDoc => {
                if (designDoc.exists) {
                  designs.push(designDoc.id);
                }
              });
              return;
            })
        );

        // CUSTOMERS
        promises.push(
          dbFS
            .collection('customers')
            .where('email', '==', users[i].email)
            .get()
            .then(customersData => {
              customersData.forEach(async customerDoc => {
                if (customerDoc.exists) {
                  customers.push(customerDoc.id);
                }
              });
              return;
            })
        );
      }
      Promise.all(promises)
        .then(done => {
          console.log('done', orderList);
          console.log('done orderListArray', orderListArray);
          console.log('done customer', customers);
          console.log('done maps', maps);
          console.log('done lists', lists);
          console.log('done designs', designs);
          console.log('done payments', payments);
        })
        .catch(error => {
          console.log('error', error);
        });
    },

    async migrateOrdersToGrowmail() {
      const growmailSiteSettings = await this.getSiteSettingsBySiteId('-Ls27CixwWnltalW_ae_');
      // Products & Product Details from API
      const growmailProducts = this.getProducts();
      const productsData = this.getProductsDataFromApi();
      // Users & Locations
      const growmailUsers = this.getUsersFromDestinationSite();
      const growmailLocations = this.getUsersLocationsFromDestinationSite();

      const referencePromises = [];
      const assets = [];
      const orderDataBackup = [];
      // locations related info
      const withDefLocations = [];
      const withoutDefLocations = [];
      const sentfromAMP = [];
      const originalCAMP = [];

      const extraAvailable = [];
      const missingLocations = [];
      const missingProducts = {};

      // Get Growmail products from API:
      // eslint-disable-next-line
      return new Promise(async (resolve, reject) => {
        console.log('Growmail Products from API');

        // LIST OF ORDERS ON SPECIFIC CAMP SITE
        const firebaseIdList = this.firebaseIdListFromFront.split(',');
        console.log('FirebaseIDList: ', firebaseIdList);

        for (let firebaseId in firebaseIdList) {
          if (firebaseIdList[firebaseId]) {
            //GET Order Object from db by Firebase ID
            const orderRef = dbFS.collection('orders').doc(firebaseIdList[firebaseId]);
            const orderRootFromDB = await orderRef.get();
            const orderRootMeta = orderRootFromDB.data();

            console.log(`Order root: ${firebaseIdList[firebaseId]}: `, orderRootMeta);
            if (orderRootMeta.extra_qty !== '' && orderRootMeta.extra_qty > 0) {
              extraAvailable.push(firebaseIdList[firebaseId]);
            }

            referencePromises.push(
              orderRef
                .collection('order_data')
                .get()
                .then(orderDataObj => {
                  const orderData = {};
                  orderDataObj.forEach(doc => {
                    if (doc.exists) {
                      if (doc.id === 'customer' || doc.id === 'product' || doc.id === 'delivery') {
                        orderData[doc.id] = doc.data();
                      } else if (doc.id === 'assets') {
                        const assetsData = doc.data();
                        for (let i in assetsData) {
                          if (assetsData[i].length > 0) {
                            assets.push(firebaseIdList[firebaseId]);
                          }
                        }
                      }
                    }
                  });

                  console.log(`ORDER ${firebaseIdList[firebaseId]}: `, orderData);
                  orderDataBackup.push({
                    order_id: firebaseIdList[firebaseId],
                    order_data: orderData
                  });

                  // MATCHING PRODUCTS ON GROWMAIL
                  const currentProductName = orderData.product.name;
                  const internalProdID = orderData.product.internal_product_id;
                  console.log('currentProductName: ', currentProductName);

                  if (currentProductName.includes('CUSTOM')) {
                    console.log('CUSTOM PRODUCT: ', currentProductName);
                    console.log('Changed Name: ', `1×1 Custom ${currentProductName.split('CUSTOM ')[1]}`);
                  }

                  const growmailProdData = this.getProductDataByName(growmailProducts, productsData, currentProductName, internalProdID);

                  if (!growmailProdData) {
                    console.log('MISSING PRODUCT: ', firebaseIdList[firebaseId]);
                    if (!missingProducts[currentProductName]) {
                      missingProducts[currentProductName] = [];
                      missingProducts[currentProductName].push(firebaseIdList[firebaseId]);
                    } else {
                      missingProducts[currentProductName].push(firebaseIdList[firebaseId]);
                    }

                    return reject();
                  }

                  // MATCHING CUSTOMER
                  const userData = this.getMatchedUser(orderData.customer.additional.email, growmailUsers);
                  if (!userData) {
                    console.log('MISSING USER: ', firebaseIdList[firebaseId]);
                    return reject();
                  }

                  // MATCHING LOCATIONS
                  let currentCustomerDefLocation = '';
                  let currentCustomerDefState = '';

                  if (orderData.customer.customer_location.default_location) {
                    withDefLocations.push(firebaseIdList[firebaseId]);
                    currentCustomerDefLocation = orderData.customer.customer_location.default_location.id;
                    currentCustomerDefState = orderData.customer.customer_location.default_location.state;
                  } else {
                    withoutDefLocations.push(firebaseIdList[firebaseId]);
                    currentCustomerDefLocation = orderData.customer.customer_location.wp_location_id;
                    currentCustomerDefState = orderData.customer.customer_location.state;
                  }

                  if (currentCustomerDefLocation > -1) {
                    const location = growmailLocations.find(
                      item =>
                        (item.location_id_legacy_imagemedia && Number(item.location_id_legacy_imagemedia) === currentCustomerDefLocation) ||
                        (item.location_id_legacy_sonicprint && Number(item.location_id_legacy_sonicprint) === currentCustomerDefLocation) ||
                        (item.location_id_legacy_onebrandcamp && Number(item.location_id_legacy_onebrandcamp) === currentCustomerDefLocation) ||
                        (item['Location City'] &&
                          item['Location City'] === orderData.customer.customer_location.city.trim() &&
                          item['Location Address'] &&
                          item['Location Address'] === orderData.customer.customer_location.street.trim())
                    );
                    let userLocation = location && Object.keys(location).length ? location : '';
                    console.log('SelectedLoc object: ', userLocation);

                    if (orderData.customer.original_customer) {
                      sentfromAMP.push(firebaseIdList[firebaseId]);
                    } else {
                      originalCAMP.push(firebaseIdList[firebaseId]);
                    }

                    if (!userLocation) {
                      console.log('MISSING LOCATION: ', firebaseIdList[firebaseId]);
                      missingLocations.push(firebaseIdList[firebaseId]);
                      userLocation = {
                        location_id: currentCustomerDefLocation,
                        location_state: currentCustomerDefState
                      };
                    }

                    // SET Customer Location
                    if (!orderData.customer.customer_location.default_location) {
                      // No default location - create & save

                      orderData.customer.customer_location.default_location = {
                        id: userLocation.location_id,
                        state: userLocation.location_state
                      };
                    } else {
                      // Default location is available - update
                      orderData.customer.customer_location.default_location.id = userLocation.location_id;
                      orderData.customer.customer_location.default_location.state = userLocation.location_state;
                    }

                    // if no selected address - > customer location  = user's default location
                    if (!orderData.delivery?.method && !orderRootMeta.extra_qty) {
                      orderData.customer.customer_location.wp_location_id = userLocation.location_id;
                    } else if (orderData.customer.customer_location.wp_location_id !== orderData.customer.customer_location.default_location.id) {
                      console.log('SELECTED LOC: ', firebaseIdList[firebaseId]);
                      const selectedLocationId = orderData.customer.customer_location.wp_location_id;

                      const gmLoc = growmailLocations.find(
                        item =>
                          (item.location_id_legacy_imagemedia && Number(item.location_id_legacy_imagemedia) === selectedLocationId) ||
                          (item.location_id_legacy_sonicprint && Number(item.location_id_legacy_sonicprint) === selectedLocationId) ||
                          (item.location_id_legacy_onebrandcamp && Number(item.location_id_legacy_onebrandcamp) === selectedLocationId)
                      );
                      const gmLocObj = gmLoc && Object.keys(gmLoc).length ? gmLoc : '';
                      console.log('SelectedLoc object: ', gmLocObj);
                      if (gmLocObj) {
                        orderData.customer.customer_location.wp_location_id = gmLocObj.location_id;
                      }
                    }
                  } else {
                    console.log('DEF hardcoded location: ', firebaseIdList[firebaseId]);
                  }

                  // SET Customer Location - END

                  // Set Product Data
                  orderData.product.category = growmailProdData.category;
                  orderData.product.category_data = growmailProdData.category_data;
                  orderData.product.image = growmailProdData.image;
                  orderData.product.internal_product_id = growmailProdData.internal_product_id;
                  orderData.product.product_id = growmailProdData.product_id;
                  orderData.product.salesforce_pricebook_entry_id = growmailProdData.salesforce_pricebook_entry_id;
                  orderData.product.salesforce_product_id = growmailProdData.salesforce_product_id;
                  orderData.product.type = growmailProdData.type;
                  orderData.product.type_data = growmailProdData.type_data;
                  //Set Customer Data
                  orderData.customer.crm_customer_id = userData.crm_customer_id;
                  orderData.customer.wp_customer_id = userData.wp_user_id;
                  orderData.customer.unique_id = `${growmailSiteSettings.firebase_id}_${growmailSiteSettings.site_id}_${userData.wp_user_id}_${userData.crm_customer_id}`;

                  console.log('UPDATED ORDER_DATA - Customer: ', orderData.customer);
                  console.log('UPDATED ORDER_DATA - Product: ', orderData.product);

                  //Set Order Root Data:
                  const orderRoot = {
                    crm_customer_id: userData.crm_customer_id,
                    customer_unique_id: `${growmailSiteSettings.firebase_id}_${growmailSiteSettings.site_id}_${userData.wp_user_id}_${userData.crm_customer_id}`,
                    site_db_id: growmailSiteSettings.firebase_id,
                    site_id: growmailSiteSettings.site_id,
                    site_name: growmailSiteSettings.site_name,
                    product_name: orderData.product.name
                  };

                  console.log('UPDATED ORDER ROOT: ', orderRoot);

                  return Promise.all([
                    orderRef.collection('order_data').doc('customer').update({
                      customer_location: orderData.customer.customer_location,
                      crm_customer_id: orderData.customer.crm_customer_id,
                      unique_id: orderData.customer.unique_id,
                      wp_customer_id: orderData.customer.wp_customer_id
                    }),
                    orderRef.collection('order_data').doc('product').update({
                      category: orderData.product.category,
                      category_data: orderData.product.category_data,
                      image: orderData.product.image,
                      internal_product_id: orderData.product.internal_product_id,
                      product_id: orderData.product.product_id,
                      salesforce_pricebook_entry_id: orderData.product.salesforce_pricebook_entry_id,
                      salesforce_product_id: orderData.product.salesforce_product_id,
                      type: orderData.product.type,
                      type_data: orderData.product.type_data
                    }),
                    orderRef.update({
                      crm_customer_id: orderRoot.crm_customer_id,
                      customer_unique_id: orderRoot.customer_unique_id,
                      site_db_id: orderRoot.site_db_id,
                      site_id: orderRoot.site_id,
                      site_name: orderRoot.site_name,
                      product_name: orderRoot.product_name
                    })
                  ]);
                })
            );
          }
        }

        // ========== MIGRATION ORDER SCRIPT END ==========

        return Promise.all(referencePromises)
          .then(result => {
            console.log('Migrate order to Growmail has succeeded. DONE: ', result);
          })
          .catch(error => {
            console.log('Migrate order to Growmail has failed: ', error);
            console.log('ASSETS: ', assets);
            console.log('OrderData: ', orderDataBackup);
          })
          .finally(() => {
            console.log('ASSETS: ', assets);
            console.log('OrderData: ', orderDataBackup);
            console.log('withDefLocations: ', withDefLocations);
            console.log('withoutDefLocations: ', withoutDefLocations);
            console.log('sentfromAMP: ', sentfromAMP);
            console.log('originalCAMP: ', originalCAMP);
            console.log('extraAvailable: ', extraAvailable);
            console.log('missingLocations: ', missingLocations);
            console.log('missingProducts: ', missingProducts);
          });
      });
    },
    async migrateMapsToGrowmail() {
      const growmailSiteSettings = await this.getSiteSettingsBySiteId('-Ls27CixwWnltalW_ae_');
      const growmailUsers = this.getUsersFromDestinationSite();

      const referencePromises = [];

      return new Promise((resolve, reject) => {
        const firebaseIdList = this.firebaseIdListFromFront.split(',');
        console.log('FirebaseIDList: ', firebaseIdList);

        for (let firebaseId in firebaseIdList) {
          const mapRef = dbFS.collection('maps').doc(firebaseIdList[firebaseId]);

          referencePromises.push(
            mapRef.get().then(mapData => {
              const map = mapData.data();

              // MATCHING CUSTOMER
              const userData = this.getMatchedUser(map.customer.email, growmailUsers);
              if (!userData) {
                console.log('MISSING USER: ', firebaseIdList[firebaseId]);
                return reject();
              }

              const newMap = {
                clientId: `${growmailSiteSettings.firebase_id}_${growmailSiteSettings.site_id}_${userData.wp_user_id}_${userData.crm_customer_id}`,
                crmCustomerId: userData.crm_customer_id,
                siteDbId: growmailSiteSettings.firebase_id,
                'customer.clientId': `${growmailSiteSettings.firebase_id}_${growmailSiteSettings.site_id}_${userData.wp_user_id}_${userData.crm_customer_id}`,
                'customer.crmCustomerId': userData.crm_customer_id
              };

              console.log('migrateMapsToGrowmail newMap Obj:', newMap);

              return mapRef.update(newMap);
            })
          );
        }

        // ========== MIGRATION ORDER SCRIPT END ==========

        return Promise.all(referencePromises)
          .then(result => {
            console.log('DONE: ', result);
          })
          .catch(error => {
            console.log('Migrate has failed: ', error);
          });
      });
    },
    async migrateListsToGrowmail() {
      const growmailSiteSettings = await this.getSiteSettingsBySiteId('-Ls27CixwWnltalW_ae_');
      const growmailUsers = this.getUsersFromDestinationSite();

      const referencePromises = [];

      return new Promise((resolve, reject) => {
        // LISTS ON SPECIFIC CAMP SITE
        const firebaseIdList = this.firebaseIdListFromFront.split(',');
        console.log('FirebaseIDList: ', firebaseIdList);

        for (let firebaseId in firebaseIdList) {
          const listRef = dbFS.collection('mailingLists').doc(firebaseIdList[firebaseId]);

          referencePromises.push(
            listRef.get().then(listData => {
              const list = listData.data();

              // MATCHING CUSTOMER
              const userData = this.getMatchedUser(list.customer.userEmail, growmailUsers);
              if (!userData) {
                console.log('MISSING USER: ', firebaseIdList[firebaseId]);
                return reject();
              }

              const newList = {
                clientId: `${growmailSiteSettings.firebase_id}_${growmailSiteSettings.site_id}_${userData.wp_user_id}_${userData.crm_customer_id}`,
                crmCustomerId: userData.crm_customer_id,
                siteDbId: growmailSiteSettings.firebase_id,
                'customer.clientId': `${growmailSiteSettings.firebase_id}_${growmailSiteSettings.site_id}_${userData.wp_user_id}_${userData.crm_customer_id}`,
                'customer.crmCustomerId': userData.crm_customer_id
              };

              console.log('migrateListsToGrowmail newList:', newList);

              return listRef.update(newList);
            })
          );
        }

        // ========== MIGRATION ORDER SCRIPT END ==========

        return Promise.all(referencePromises)
          .then(result => {
            console.log('DONE- Lists are migrated: ', result);
          })
          .catch(error => {
            console.log('Migrating Lists has failed: ', error);
          });
      });
    },
    async migrateDesignToGrowmail() {
      // TODO:
      const growmailSiteSettings = await this.getSiteSettingsBySiteId('-Ls27CixwWnltalW_ae_');
      const growmailUsers = this.getUsersFromDestinationSite();

      const referencePromises = [];

      return new Promise((resolve, reject) => {
        const firebaseIdList = this.firebaseIdListFromFront.split(',');
        console.log('FirebaseIDList: ', firebaseIdList);

        for (let firebaseId in firebaseIdList) {
          const designRef = dbFS.collection('customDesigns').doc(firebaseIdList[firebaseId]);

          referencePromises.push(
            designRef.get().then(designData => {
              const design = designData.data();

              // MATCHING CUSTOMER
              const userData = this.getMatchedUser(design.customer.userEmail, growmailUsers);
              if (!userData) {
                console.log('MISSING USER: ', firebaseIdList[firebaseId]);
                return reject();
              }

              const newDesign = {
                clientId: `${growmailSiteSettings.firebase_id}_${growmailSiteSettings.site_id}_${userData.wp_user_id}_${userData.crm_customer_id}`,
                crmCustomerId: userData.crm_customer_id,
                siteDbId: growmailSiteSettings.firebase_id,
                'customer.clientId': `${growmailSiteSettings.firebase_id}_${growmailSiteSettings.site_id}_${userData.wp_user_id}_${userData.crm_customer_id}`,
                'customer.crmCustomerId': userData.crm_customer_id
              };

              console.log('migrateDesignToGrowmail newDesign:', newDesign);

              return designRef.update(newDesign);
            })
          );
        }

        // ========== MIGRATION ORDER SCRIPT END ==========

        return Promise.all(referencePromises)
          .then(result => {
            console.log('DONE - Designs are migrated: ', result);
          })
          .catch(error => {
            console.log('Migrating Designs has failed: ', error);
          });
      });
    },
    async migratePaymentsToGrowmail() {
      const growmailSiteSettings = await this.getSiteSettingsBySiteId('-Ls27CixwWnltalW_ae_');

      const campUsersFile = require('@/assets/migration/growmail_all_users_legacy_2022.json');
      const campUsers = campUsersFile.users;

      const referencePromises = [];

      return new Promise((resolve, reject) => {
        const firebaseIdList = this.firebaseIdListFromFront.split(',');
        console.log('FirebaseIDList: ', firebaseIdList);

        for (let firebaseId in firebaseIdList) {
          const paymentRef = dbFS.collection('payments').doc(firebaseIdList[firebaseId]);

          referencePromises.push(
            paymentRef.get().then(paymentData => {
              const payment = paymentData.data();

              if (payment) {
                // MATCHING CUSTOMER
                const currentCustomerUniqueId = payment.customer_unique_id;
                console.log('[migratePaymentsToGrowmail] currentCustomerUniqueId: ', currentCustomerUniqueId);
                const splittedUniqueId = currentCustomerUniqueId.split('_');
                const old_wp_id = parseInt(splittedUniqueId[splittedUniqueId.length - 2]);
                console.log('[migratePaymentsToGrowmail] old_wp_id: ', old_wp_id);
                // NOTE: Check the legacy WP IDs separately by site - see the commented out code block as example
                const user = campUsers.find(item => item.wp_id_legacy_growmail === old_wp_id);
                // const user = campUsers.find(item => item.wp_id_legacy_imagemedia === old_wp_id);
                // const user = campUsers.find(item => item.wp_id_legacy_sonicprint === old_wp_id);
                // const user = campUsers.find(item => item.wp_id_legacy_onebrandcamp === old_wp_id);

                const userData = user && Object.keys(user).length ? user : '';

                if (!userData) {
                  console.log('MISSING USER: ', firebaseIdList[firebaseId]);
                  return reject();
                }

                const newPayment = {
                  customer_unique_id: `${growmailSiteSettings.firebase_id}_${growmailSiteSettings.site_id}_${userData.wp_user_id}_${userData.crm_customer_id}`,
                  site_db_id: growmailSiteSettings.firebase_id,
                  site_id: growmailSiteSettings.site_id
                };

                console.log('[migratePaymentsToGrowmail] newPayment: ', newPayment);
                return paymentRef.update(newPayment);
              }
            })
          );
        }

        // ========== MIGRATION ORDER SCRIPT END ==========

        return Promise.all(referencePromises)
          .then(result => {
            console.log('DONE - Payments are migrated: ', result);
          })
          .catch(error => {
            console.log('Migrating Payments has failed: ', error);
          });
      });
    },
    async migrateCustomersToGrowmail() {
      const growmailSiteSettings = await this.getSiteSettingsBySiteId('-Ls27CixwWnltalW_ae_');
      const growmailUsers = this.getUsersFromDestinationSite();
      const referencePromises = [];

      return new Promise((resolve, reject) => {
        const firebaseIdList = this.firebaseIdListFromFront.split(',');
        console.log('FirebaseIDList: ', firebaseIdList);

        for (let firebaseId in firebaseIdList) {
          const customerRef = dbFS.collection('customers').doc(firebaseIdList[firebaseId]);

          referencePromises.push(
            customerRef.get().then(customerData => {
              const customer = customerData.data();
              // MATCHING CUSTOMER
              const userData = this.getMatchedUser(customer.email, growmailUsers);

              if (!userData) {
                console.log('MISSING USER: ', firebaseIdList[firebaseId]);
                return reject();
              }

              const newCustomer = {
                brand_id: growmailSiteSettings.brand_web_id,
                crm_customer_id: userData.crm_customer_id,
                customer_unique_id: `${growmailSiteSettings.firebase_id}_${growmailSiteSettings.site_id}_${userData.wp_user_id}_${userData.crm_customer_id}`,
                firebase_site_id: growmailSiteSettings.firebase_id,
                site_id: growmailSiteSettings.site_id,
                wp_user_id: userData.wp_user_id
              };

              console.log('migratePaymentsToGrowmail newCustomer: ', newCustomer);

              return customerRef.update(newCustomer).then(result => {
                console.log('Customer is updated!');

                if (customer.stripe_customer || customer.stripe_test_customer) {
                  console.log('Customer stripe data available!');
                  return this.updateCustomerInStripe({
                    firebase_customer_id: firebaseIdList[firebaseId],
                    customer: newCustomer,
                    stripe_customer: customer.stripe_customer ? customer.stripe_customer : '',
                    stripe_test_customer: customer.stripe_test_customer ? customer.stripe_test_customer : ''
                  });
                }
                return Promise.resolve();
              });
            })
          );
        }

        // ========== MIGRATION ORDER SCRIPT END ==========

        return Promise.all(referencePromises)
          .then(result => {
            console.log('DONE - Customers are migrated: ', result);
          })
          .catch(error => {
            console.log('Migrating Customers has failed: ', error);
          });
      });
    },
    updateCustomerInStripe(payload) {
      console.log('updateCustomerInStripe payload:', payload);
      const customer = payload.customer;

      const config = {
        stripe_test_customer: payload.stripe_test_customer,
        stripe_customer: payload.stripe_customer,
        metadata: {
          brand_id: customer.brand_id,
          customer_unique_id: customer.customer_unique_id,
          firebase_customer_id: payload.firebase_customer_id,
          firebase_site_id: customer.firebase_site_id,
          osprey_customer_id: customer.crm_customer_id
        }
      };
      console.log('updateCustomerInStripe config:', config);
      return cloudFunctionsPost('/api/customers/stripe-metadata', config);
    },
    createMatchedUsers() {
      //{
      // "crm_customer_id": 62878,
      // "email": "martongergo@gmail.com",
      // "wp_user_id": 17
      //
      // -Ls2_EfzDGehOPEYBPzK_OBOPP-2_17_52406
      // },
      const ordersRootBackupFile = require('@/assets/migration/forhim_order_root_backup.json');
      const orderRoots = ordersRootBackupFile.orders;

      const result = [];
      let orderData = '';
      let splittedUniqueId = '';

      for (let i in orderRoots) {
        orderData = orderRoots[i].order_data;
        splittedUniqueId = orderData.crm_customer_id.split('_');

        result.push({
          crm_customer_id: orderData.crm_customer_id,
          email: orderData.crm_customer_id.order_email,
          wp_user_id: splittedUniqueId[splittedUniqueId.length - 2]
        });
      }

      console.log('RESULT - ', result);
    },
    //Migrate orders from Clipper V2 to CMAG
    /* eslint-disable no-mixed-spaces-and-tabs */
    getFirebaseOrderIdsPerSite: function (siteID) {
      /* eslint-disable no-mixed-spaces-and-tabs */
      const idList = [];
      const ordersWithCrmID = [];
      const ordersWithoutCrmID = [];
      const dataList = [];
      const ordersByProducts = {};
      let resultDoc = null;

      console.log('getFirebaseOrderIdsPerSite: ', siteID);
      dbFS
        .collection('orders')
        .where('site_db_id', '==', siteID)
        .get()
        .then(data => {
          console.log('RESULT');
          console.log(data);

          data.forEach(doc => {
            if (doc.exists) {
              resultDoc = doc.data();
              if (resultDoc.crm_order_id > 0) {
                ordersWithCrmID.push({
                  firebase_order_id: resultDoc.firebase_order_id,
                  crm_order_id: resultDoc.crm_order_id
                });
              } else {
                ordersWithoutCrmID.push({
                  firebase_order_id: resultDoc.firebase_order_id,
                  crm_order_id: resultDoc.crm_order_id
                });
              }

              if (resultDoc.product_name) {
                if (!ordersByProducts[resultDoc.product_name]) {
                  ordersByProducts[resultDoc.product_name] = [];
                }
                ordersByProducts[resultDoc.product_name].push(doc.id);
              }

              idList.push(doc.id);

              dataList.push({
                order_id: doc.id,
                order_data: resultDoc
              });
            }
          });
          console.log('Firebase ID List: ', idList);
          console.log('Firebase ID + Order Data: ', dataList);
          console.log('Firebase Order IDs by Product Names: ', ordersByProducts);
          console.log('ordersWithCrmID: ', ordersWithCrmID);
          console.log('ordersWithoutCrmID: ', ordersWithoutCrmID);
        });
      /* eslint-enable no-mixed-spaces-and-tabs */
    },
    async getProductsFromOrderByProductName(productname) {
      // TODO: Add the order ID list
      dbFS
        .collection('orders')
        .where('site_db_id', '==', this.selectedSiteToMigrate)
        .get()
        .then(orders => {
          console.log('getProductsFromOrderByProductName RESULT Orders: ');
          console.log(orders);

          const productList = {};
          const promises = [];
          const assets = [];
          let productName = null;
          let productID = null;

          orders.forEach(async orderDoc => {
            if (orderDoc.exists) {
              promises.push(
                dbFS
                  .collection('orders')
                  .doc(orderDoc.id)
                  .collection('order_data')
                  .doc('product')
                  .get()
                  .then(productData => {
                    productName = orderDoc.data()?.product_name || '';

                    if (productName) {
                      if (productList[productName] === undefined) {
                        productList[productName] = {};
                      }

                      productID = productData.data()?.product_id || '';

                      if (productID) {
                        if (productList[productName][productID] === undefined) {
                          productList[productName][productID] = [];
                        }
                        productList[productName][productID].push({
                          product_id: productID,
                          order_id: orderDoc.id,
                          salesforce_product_id: productData.data().salesforce_product_id,
                          salesforce_price_entry: productData.data().salesforce_pricebook_entry_id
                        });
                      } else {
                        console.log('No product ID: ', orderDoc.id);
                      }
                    } else {
                      console.log('No product Name: ', orderDoc.id);
                    }
                    return;
                  })
              );
              // Get assets
              promises.push(
                dbFS
                  .collection('orders')
                  .doc(orderDoc.id)
                  .collection('order_data')
                  .doc('assets')
                  .get()
                  .then(assetsData => {
                    const assetsList = assetsData.data();
                    for (let i in assetsList) {
                      if (assetsList[i].length > 0) {
                        assets.push({
                          firebaseID: orderDoc.id,
                          data: assetsList[i]
                        });
                      }
                    }
                    return;
                  })
              );
            }
          });

          Promise.all(promises).then(result => {
            console.log('getProductsFromOrderByProductName productListproductList: ', productList);
            console.log('getProductsFromOrderByProductName assets: ', assets);
          });
        });
    },
    getOrdersRelatedDataIdsBySite: function (siteID) {
      const maps = [];
      const lists = [];
      const designs = [];
      const payments = [];
      const customers = [];
      const promises = [];

      // MAPS
      promises.push(
        dbFS
          .collection('maps')
          .where('siteDbId', '==', siteID)
          .get()
          .then(mapsData => {
            mapsData.forEach(async mapDoc => {
              if (mapDoc.exists) {
                maps.push(mapDoc.id);
              }
            });
            return;
          })
      );
      // LIST
      promises.push(
        dbFS
          .collection('mailingLists')
          .where('siteDbId', '==', siteID)
          .get()
          .then(listsData => {
            listsData.forEach(async listDoc => {
              if (listDoc.exists) {
                lists.push(listDoc.id);
              }
            });
            return;
          })
      );
      // DESIGN
      promises.push(
        dbFS
          .collection('customDesigns')
          .where('siteDbId', '==', siteID)
          .get()
          .then(designsData => {
            designsData.forEach(async designDoc => {
              if (designDoc.exists) {
                designs.push(designDoc.id);
              }
            });
            return;
          })
      );
      // PAYMENT
      promises.push(
        dbFS
          .collection('payments')
          .where('site_db_id', '==', siteID)
          .get()
          .then(paymentsData => {
            paymentsData.forEach(async paymentDoc => {
              if (paymentDoc.exists) {
                payments.push(paymentDoc.id);
              }
            });
            return;
          })
      );

      // CUSTOMERS
      promises.push(
        dbFS
          .collection('customers')
          .where('firebase_site_id', '==', siteID)
          .get()
          .then(customersData => {
            customersData.forEach(async customerDoc => {
              if (customerDoc.exists) {
                customers.push(customerDoc.id);
              }
            });
            return;
          })
      );

      Promise.all(promises)
        .then(result => {
          console.log('getOrdersRelatedDataIdsBySite has succeeded: ', result);
          console.log('MAPS: ', maps);
          console.log('LISTS ', lists);
          console.log('DESIGNS', designs);
          console.log('PAYMENTS', payments);
          console.log('CUSTOMERS', customers);
        })
        .catch(error => {
          console.log('getOrdersRelatedDataIdsBySite has failed: ', error);
        });
    },
    getDataByFilters() {
      /* eslint-disable no-mixed-spaces-and-tabs */
      const clipperSiteData = {
        additional_services_available: false,
        bill_corporate_account: true,
        brand_web_id: '20',
        charge_test_mode: false,
        checkout_order_enabled: false,
        client_logo: `${process.env.VUE_APP_FIREBASE_STORAGE_URL}sites%2Fclipperlogo.png_1558361469952?alt=media&token=8b36273f-a917-4688-ae5a-fabe5953bb98`,
        contact_phone: '(866) 357-1333',
        created_at: 1558363656425,
        credit_card_payment_enabled: false,
        crm_api_endpoint: 'https://osprey.onebrand.io/v2',
        custom_quote_url: 'https://clipper2.onebrand.net/custom-quote/',
        design_live_asset_folder_path: 'cmag.onebrand.net',
        download_quote_enabled: true,
        enable_external_quote_saving: false,
        env_type: 'amp',
        fifty_percent_payment_enabled: false,
        firebaseId: '-LGjZtGpLePH-61Rp662',
        firebase_id: '-LfHu_oteR42roiQapLT',
        header_image_large: `${process.env.VUE_APP_FIREBASE_STORAGE_URL}sites%2Fclipper_mailprintdigital_web_new.png_1550592090955?alt=media&token=38aae29b-521f-4e28-bff7-fc1b5a1314cd`,
        header_image_small: false,
        is_maintenance: 0,
        manual_discount_available: false,
        marketing_manager_email: 'jeff+clipper@imagemedia.com',
        onebrand_payment_api_endpoint: 'https://api.onebrand.io/payments/wp-payment',
        order_page_hero_text:
          '<p><strong>Product Highlights</strong></p>\n<ul>\n<li>Solo postcard mailed only to New Mover households within a specific geography anywhere in the continental U.S. Postcards are delivered via First-Class Mail.</li>\n<li>6&rdquo; x 9&rdquo; full-color front and back with bleed, printed on 14# card stock.</li>\n<li>Minimum order is 250 Average Movers Per Month with a minimum 6-month contract.</li>\n<li>Geographies are selected, and a scenario is created on this site. Once the customer approves the scenario, it is converted to a pre-order to generate a unique Order ID Number. The Order ID Number must appear on the New Movers Postcard contract.</li>\n<li>Submit ad copy in ATOL. If you don&rsquo;t see your ad, search &ldquo;Live Ads&rdquo;, then search by account number.</li>\n</ul>',
        order_page_hero_title: 'Welcome to the Clipper Magazine® V2 Platform',
        register_user_fields: ['Client ID'],
        register_user_fields_enabled: true,
        salesforce_opportunity_enabled: false,
        sftp_upload_enabled: false,
        show_legacy_orders: true,
        show_order_approval: true,
        site_api_key: 'Basic bWFydG9uOk50VnVxZTY3f',
        site_api_password: '4aJI DOBh 94VA Kk1x 245C eceM',
        site_api_username: 'webgurus',
        site_id: 'clipper-v2',
        site_name: 'Clipper Anytime V2',
        site_type: 'live',
        site_url: '//clipper2.onebrand.net/wp-json/amp/v2/',
        stripe_live_key: 'pk_live_o993XVEnbgQyZe9SwMlQctSv',
        stripe_logo: 'https://devtest.onebrand.net/wp-content/uploads/sites/43/2018/03/logo_dark_themeforest.png',
        stripe_mode: 'live',
        stripe_test_key: 'pk_test_9ZfF0E0hFto4xgZhAphk5OVo',
        tax_enabled: true,
        terms_and_conditions:
          '<p><strong>IMPORTANT TERMS AND CONDITIONS FOR PLACING AN ORDER WITH OneBrand Marketing (&ldquo;we&rdquo;, &ldquo;us&rdquo;, or &ldquo;our&rdquo;). By placing an order, you agree to the following terms and conditions (&ldquo;Agreement&rdquo;). </strong><strong>Please read them carefully before placing an order</strong><strong>.</strong></p>\n<ol>\n<li><strong>SERVICES PROVIDED</strong><strong>:&nbsp;</strong>We provide graphic design, printing materials, mailing preparation, online advertising, and other marketing support services. We do not guarantee or represent that we will provide a return on investment, guaranteed income, leads, orders, customers, response rates, or any desired, expected, or intended results.&nbsp;&nbsp;</li>\n<li><strong>TURNAROUND</strong><strong>:&nbsp;</strong>We use commercially reasonable efforts to meet your expectations and requests, including production and shipping dates. However, quoted and published ship or mail dates are best estimates and not to be considered guarantees.&nbsp;&nbsp;</li>\n<li><strong>SCHEDULE</strong><strong>:&nbsp;</strong>Production turnaround time begins after you approve your proof. For proofs approved after 12:00 pm (Eastern Time), production turnaround time will begin the next business day. Business days are considered Monday through Friday. Holidays are excluded from business days.&nbsp;</li>\n<li><strong>PAYMENT TERMS</strong><strong>:&nbsp;</strong>All orders must be prepaid before commencing production. We reserve the right to place jobs on indefinite hold if the credit card declines or for payment pending via check. There are no net credit terms accounts unless pre-approved in writing by management and secured by credit card or deposit. You authorize us to charge any credit card or debit card previously authorized for unpaid or overdue accounts not received within payment terms (if applicable). &nbsp;Additionally, you authorize us to charge any credit card or debit card previously used for nonsufficient funds (NSF or returned) checks. There is a fee of $35 for any nonsufficient funds checks.&nbsp;</li>\n<li><strong>ALL SALES ARE FINAL</strong><strong>:</strong>&nbsp;Because each print job is created custom for you, it cannot be reused or resold. ALL SALES ARE FINAL.&nbsp;</li>\n<li><strong>ORDER CANCELLATIONS AND REFUNDS</strong><strong>:&nbsp;</strong>Credits or refunds for cancellation of orders are available on orders that have NOT been placed into production. If an order is cancelled AFTER we have sent a proof to you, but BEFORE it is approved by you, a refund will be provided to you less a $50 administrative fee for work completed prior to cancellation. If an order is cancelled AFTER a proof is approved by you but BEFORE it is placed into production, on written cancellation a refund will be given less a $100 fee for all work completed prior to cancellation. There are no refunds if an order is cancelled AFTER it has been placed into production.Orders with custom dies, third-party services (such as variable data postcards or post-press services), or special &ldquo;non-returnable&rdquo; paper stocks are not refundable after the order is placed.&nbsp;</li>\n<li>If you need to cancel an order placed, you must email the cancellation request to sales@onebrandmarketing.com AND call and speak with our representative to confirm receipt of the cancellation and the cancellation charges at that point in time. &nbsp;Sending the email, or livechat, without confirmation is not enough to cancel an order.<br />No reprints or credits are offered for the following reasons (these are not considered defects):\n<p>&nbsp;</p>\n<ul>\n<li>Low resolution or low quality graphics and images as supplied by you</li>\n<li>Spelling, punctuation, and grammatical errors from your approved proof</li>\n<li>Damaged fonts</li>\n<li>Transparency</li>\n<li>Overprint<br />&middot; Color reproduction</li>\n<li>Artwork files that are not created following our or USPS specifications</li>\n<li>Variances in color from the conversion of Pantone or RGB colors to CMYK</li>\n<li>Errors in user-selected options such as size, quantity, paper and finish</li>\n<li>Duplicate orders submitted by you</li>\n<li>Incorrect files uploaded by you</li>\n<li>Incorrect file orientation on your provided files.</li>\n<li>Cracking on folds</li>\n<li>Cutting variances</li>\n<li>Incorrect or undeliverable shipping address</li>\n</ul>\n</li>\n<li><strong>CLAIMS AND RETURNS</strong><strong>:&nbsp;</strong>Claims for defects, damages, or shortages must be timely made by you in writing no later than 10 calendar days after delivery. If no such claim is made, you agree the order and performance tendered by us have been accepted. If a job is unacceptable to you due to true defects in workmanship, and all the materials shipped are returned to us for inspection and confirmation of the defects, we will reprint the job at no cost, or issue a credit for future orders. No cash refunds are offered. Please note that the FULL original order must be returned to us and inspected.&nbsp;\n<p>&nbsp;</p>\n<ul>\n<li><strong>SHIPPING TERMS</strong><strong>:</strong>&nbsp;All shipments are FOB Shipping Point from our manufacturing location. We assume no liability for damage in shipping, missing, or otherwise delayed shipments.&nbsp;</li>\n</ul>\n</li>\n<li><strong>COLOR REPRODUCTION</strong><strong>:&nbsp;</strong>Because of differences in equipment manufacturers, including paper, inks, lighting, and other conditions, all print jobs utilize a &ldquo;pleasing color&rdquo; spectrum as determined by generally accepted printing trade practices. The color output of your print job is not guaranteed to match any other print order or previous printed copy. We are not responsible for color variations between submitted files and the final printed piece. Under no circumstances will a reprint be honored for color variations that have occurred during the printing process.&nbsp;</li>\n<li><strong>PROOFING PROCESS</strong><strong>:</strong>&nbsp;If you select &ldquo;online proof&rdquo; or request a digital proof, we will send an email notice shortly after receiving it into our production department. &nbsp;Please take note that an online proof is not an accurate color reproduction of the final printed piece but is a final opportunity for you to check the layout, bleeds, crops, and final text. &nbsp;The proofing process is very important to avoid any unintended issues.Approval of the correct and final print version is your sole responsibility. We are not responsible for any copy or design errors committed on edits once approved by you.<br /><br /></li>\n<li><strong>COLOR PRINTER AND INKJET OR COLOR COPIES</strong><strong>:</strong>&nbsp;Inkjet and laser prints will look substantially different than commercial offset printing. We offer quick turnaround and low prices by printing to a &ldquo;pleasing color&rdquo; standard, using standard ink densities. There is no guarantee that your finished piece will match its printed sample. This is due to the varying results from different output devices including inkjet printers, continuous tone proofing devices, and film-based proofs. Consumer printers are known to saturate colors and glossy &ldquo;photo&rdquo; paper will look different.&nbsp;</li>\n<li><strong>CONTENT</strong><strong>:&nbsp;</strong>We reserve the right, in our sole discretion, to: i) refuse to provide service to you at any time and for any reason; or ii) print anything we deem improper, offensive, or known to be illegal. You guarantee that you have the legal authority to allow us to use all matter submitted to us by you, including but not limited to the necessary license and permission to use any copyrighted material, trademarks, or graphics. You are solely responsible for the content of all matter submitted to us by you. We are not liable for any damages resulting from violation of copyright laws or illegal use of trade names or slogans.&nbsp;</li>\n<li><strong>QUOTES AND ESTIMATES</strong><strong>:&nbsp;</strong>Written estimates are good for 30 days. An estimate not accepted within 30 days may be subject to change. Prices posted on our website are subject to change without notice. Quotations are based on the accuracy and completeness of the specifications and selections provided by you in writing. We reserve the right to modify a prior quotation made if, at the time of submission of the order, the art or other parameter does not conform to the information on which the original estimate was based.&nbsp;</li>\n<li><strong>OVERRUN/UNDERRUN</strong><strong>:</strong>&nbsp;We will normally deliver the exact quantity of goods ordered plus a small additional amount. There is no extra charge for the additional amount. Should an order be delivered with less than the amount ordered, you agree that a credit issued for the value of the shorted pieces is acceptable as full satisfaction owed for the shorted items.&nbsp;</li>\n<li><strong>CUSTOMER FILES</strong><strong>:&nbsp;</strong>It is your responsibility to maintain a copy of the original computer files, artwork. We are not responsible for accidental loss or damage to media supplied by you or for errors on supplied artwork furnished by you. We do not always archive your work for longer than it takes to produce the final product. DO NOT send any &ldquo;one-of-kind&rdquo; prints or artwork.&nbsp;</li>\n<li><strong>STOCK PHOTOGRAPHY LICENSE</strong><strong>:&nbsp;</strong>All materials we create in producing printed materials or postcards are the property of us and/or our affiliates or licensors, and are protected by copyright, trademark, and other intellectual property laws. This includes typeset layouts and color scans. We may use licensed stock images for customer designs, under our corporate license. You may not re-use the material that we create for any other purpose other than the printed piece provided by us.&nbsp;</li>\n<li><strong>USPS DISCLAIMER</strong><strong>:</strong>&nbsp;We provide design, printing service and mailing preparation services. We DO NOT provide mail delivery services. &nbsp;This service is provided by United States Postal Service (&ldquo;USPS&rdquo;). We are not USPS and cannot guarantee the delivery schedules or in-home dates of your mailings. Our services are completed when your mail is delivered to the dock of the USPS. If there is a delivery or service issue specific to USPS, we will assist you in coordinating all available resolutions with USPS directly. USPS will require specific and/or verifiable proof of error. A self-certified statement that a postcard was not received is&nbsp;not&nbsp;a verifiable error for USPS.&nbsp;</li>\n<li><strong>DISTRIBUTION VERIFICATION</strong><strong>:&nbsp;</strong>Upon request by you within 30 days of the in-home date of your mailing, we will provide you verification that your mail was deposited with the USPS.&nbsp;</li>\n<li><strong>MAILING LIST QUALITY</strong><strong>:</strong>&nbsp;We are not responsible for undeliverable or returned pieces on any supplied mailing list data provided by you regardless if we processed NCOA and CASS certifications.&nbsp;</li>\n<li><strong>PURCHASED MAILING LISTS</strong><strong>:</strong>&nbsp;Mailing lists which are purchased from us will not have returns on consumer lists exceeding 8% and on business lists exceeding 15% (&ldquo;Return Levels&rdquo;), conditional on the mailing being sent within 30 days of the purchase of the lists. We are not liable for any returns other than those in excess of the Return Levels. The sole remedy for exceeding the Return Levels shall be refund of the postage of those items that exceed the Return Levels.Due to contractual terms with third-party mailing data providers, we are unable to refund on mailing list purchases once procured regardless if the list has been mailed or used in any capacity by you.&nbsp;</li>\n<li><strong>POSTAGE FEES</strong>: You should explicitly recognize that we are not the USPS and any money paid for postage is collected and paid to USPS on your behalf. These funds are not ours and are not refundable for any reason by us. To allow sufficient time for payment deposit with the USPS, when you use our permit number, we require that all checks and credit card payments for postage be in our possession 3 days before your mail date. If a postage deposit is not received, we cannot advance the postage required, and the USPS will not accept your mail.&nbsp;</li>\n<li><strong>POSTAGE REFUNDS</strong><strong>:&nbsp;</strong>UNDER ABSOLUTELY NO CIRCUMSTANCES WILL POSTAGE BE REFUNDED FOR ANY REASON ONCE AN ORDER HAS BEEN TRANSFERRED TO THE USPS FOR MAILING.&nbsp;</li>\n<li><strong>STORAGE CHARGES</strong><strong>:&nbsp;</strong>Material held more than 90 days after production is completed will be billed at a charge of $5 per 1,000 pieces per month. If we are unable to contact you within 60 days, we will consider the material abandoned and it will be recycled.&nbsp;</li>\n<li><strong>DETACHED ADDRESS LABEL GEOGRAPHY</strong><strong>:</strong>&nbsp;We will make commercially reasonable efforts to ensure your requested geography for any detached address label postcard campaign is met, provided however, certain geographies and services may not be available for all requested mail dates. In such circumstances, we may substitute those requested geographies with available ones within a reasonable distance from the requested geography to meet your specific quantity. If the quantity changes due to these substitutions your total cost will be adjusted accordingly.&nbsp;</li>\n<li><strong>WARRANTY AND DISCLAIMER OF OTHER WARRANTY</strong><strong>:</strong>&nbsp;We make no warranties, express or implied, with respect to results you may obtain through use of our services. We intend to use commercially reasonable efforts to provide services in accordance with this Agreement; however, it is possible for errors, omissions or other mishaps to occur. We will have no liability in such case. IT IS EXPRESSLY AGREED THAT THIS WARRANTY IS IN LIEU OF ALL OTHER WARRANTIES, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO WARRANTY OF WARRANTY OF MERCHANTABILITY AND WARRANTY OF FITNESS FOR A PARTICULAR PURPOSE. WITHOUT LIMITING THE GENERALITY OF THE FOREGOING, WE DO NOT WARRANT ANY RESULTS YOU MAY OBTAIN THROUGH SERVICES SUPPLIED BY US.&nbsp;</li>\n<li><strong>LIMITATIONS OF LIABILITY</strong><strong>:&nbsp;</strong>WE WILL NOT BE LIABLE FOR: I) ANY DIRECT DAMAGES RELATING TO ERROR, MISTAKE, OR FAILURE TO PERFORM SERVICES OF ANY NATURE THAT EXCEEDS THE VALUE OF THE FEES PAID BY YOU TO US FOR THE SPECIFIC SERVICE GIVING RISE TO THE DAMAGES; II) ANY INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL OR PUNITIVE DAMAGES, INCLUDING BUT NOT LIMITED TO LOSS OF BUSINESS, LOSS OF PROFITS, FAILURE TO OBTAIN CERTAIN BUSINESS RESULTS, RESPONSE RATES, SALES, POSTAGE OR ANY OTHER DIRECT OR CONSEQUENTIAL DAMAGES AS A RESULT OF ANY ERROR, MISTAKE, OR FAILURE OF US TO PERFORM SERVICES. THIS INCLUDES BUT IS NOT LIMITED TO; LIST ADDITIONS, REQUESTS MADE AFTER ORDER APPROVAL, AND USPS ERRORS. &nbsp;WE ARE NOT LIABLE IN ANY MANNER OR AMOUNT FOR USPS PERFORMANCE FAILURES, DAMAGE, OR DELAYS AND MAKE NO WARRANTY WHATSOEVER REGARDING USPS PERFORMANCE.&nbsp;</li>\n<li><strong>INDEMNIFICATION</strong><strong>:&nbsp;</strong>You represent that you have the legal right to produce all printed materials ordered. In the event that a charge, claim or demand, or arbitration, action or proceeding (collectively, a &ldquo;Claim&rdquo;) is made or commenced against us based upon, relating to or arising from your acts, or the printing performed or product produced by us ordered by you, you shall indemnify and hold us harmless from and against any loss, damages, cost and expense arising from or related to the Claim including without limitation; (1) defending us against any such Claim (2) paying any judgment or award against us; and (3) reimbursing us for any legal fees and expenses we reasonably incur in responding and defending the Claim.&nbsp;</li>\n<li><strong>PRIVACY POLICY AND ACCEPTABLE USE POLICY</strong><strong>:</strong>&nbsp;You agree to our Privacy Policy and Acceptable Use Policy, which are incorporated by reference into this Agreement.&nbsp;</li>\n<li><strong>DATA SECURITY AND MALWARE POLICY / DISCLAIMER OF WARRANTY</strong><strong>:&nbsp;</strong>You agree and acknowledges the following: (a) that we do not warrant that any of our websites or vendor websites or electronic services will be uninterrupted, error free, or immune from hackers that create data breaches and data theft, and further that we, and our various third-party providers (such as Amazon) may occasionally experience &ldquo;hard outages&rdquo; due to internet disruptions, or data security breaches. WE EXPRESSLY DISCLAIMS ANY WARRANTY OR ASSURANCE OF DATA INTEGRITY, SECURITY, OR PERFORMANCE. Any such breaches or outages shall not be considered a breach of these terms and conditions. Further, we agree to use reasonable commercial efforts to ensure that there are no viruses or undocumented feature in any software, email, or data files at the time of delivery to you &nbsp;(a virus will be defined as any harmful, hidden programs or data incorporated in a computer software program that destroys or impairs the program and/or data from processing its normal business operations); and the software does not contain any embedded device or code (e.g., time bomb), but we MAKE NO WARRANTY EXPRESS OR IMPLIED THAT MALICIOUS CODE WILL NOT BE PRESENT ON ANY CUSTOMER COMMUNICATION OR DATA FILES.&nbsp;</li>\n<li><strong>GOVERNING LAW AND VENUE</strong><strong>:&nbsp;</strong>This Agreement is entered into in Lancaster County, Pennsylvania, and all parties hereto consent to personal jurisdiction in the courts of the Commonwealth of Pennsylvania sitting in Lancaster County, for all actions arising under or in connection with these Agreements. This Agreement shall be governed and construed according to the laws of New York without regard to its conflict of law&rsquo;s provisions.&nbsp;</li>\n<li><strong>SEVERABILITY</strong><strong>:</strong>&nbsp;If any provision of this Agreement or the application thereof shall, for any reason and to any extent, be invalid or unenforceable, neither the remainder of this Agreement nor the application of the provision to other persons, entities or circumstances shall be affected thereby, but instead shall be enforced to the maximum extent permitted by law.&nbsp;</li>\n<li><strong>FORCE MAJEURE</strong><strong>:&nbsp;</strong>In no event shall we be responsible or liable for any failure or delay in the performance of its obligations hereunder arising out of or caused by, directly or indirectly, forces beyond our control, including, without limitation, hurricanes, tropical storms or threat of same, strikes, work stoppages, accidents, acts or threats of war or terrorism, civil or military disturbances, nuclear or natural catastrophes or acts of God, and interruptions, loss or malfunctions of utilities, communications or computer (software and hardware) services, it being understood that we shall use reasonable best efforts which are consistent with accepted practices in the printing industry to resume performance as soon as practicable under the circumstances.&nbsp;</li>\n<li><strong>AGREEMENT CHANGES</strong><strong>:</strong>&nbsp;We may change, modify, add or remove portions of this Agreement at any time, and any changes will become effective immediately upon being posted. This Agreement was last updated on October 2, 2018.</li>\n</ol>\n<p>END of TERMS AND CONDITIONS: October 2, 2018</p>',
        turnaround_days: 10,
        turnaround_rush_fee: 0,
        user_defined_fields: [
          {
            field_description: '',
            field_id: 'order_field_1',
            field_label: 'Job Number:',
            field_name: 'job_number',
            field_type: 'text'
          },
          {
            field_description: '',
            field_id: 'order_field_2',
            field_label: 'Client Name:',
            field_name: 'client_name',
            field_type: 'text'
          },
          {
            field_description: '',
            field_id: 'order_field_3',
            field_label: '',
            field_name: '',
            field_type: 'text'
          },
          {
            field_description: '',
            field_id: 'order_field_4',
            field_label: '',
            field_name: '',
            field_type: 'text'
          },
          {
            field_description: '',
            field_id: 'order_field_5',
            field_label: '',
            field_name: '',
            field_type: 'text'
          }
        ],
        user_defined_fields_enabled: true
      };
      const idList = [];
      const dataList = [];
      const references = [];
      const missingReferences = [];
      const mapReferences = [];
      const designReferences = [];
      const orderListReferences = [];
      const uploadListReferences = [];
      const laterListReferences = [];
      const ordersWithCrmID = [];
      const ordersWithoutCrmID = [];
      const paymentsList = [];
      const ordersByProducts = {};
      // get payments
      dbFS
        .collection('payments')
        .where('site_db_id', '==', '-LqLnCOm9uTYMxcrFSav')
        .where('paymentType', '==', 'stripe')
        .where('stripeType', '==', 'payment_type_50')
        .get()
        .then(data => {
          const payments = [];
          data.forEach((item, i) => {
            if (item.exists) {
              payments.push(item.id);
            }
          });
          console.log('PAYMENTS: ', payments);
        });

      dbFS
        .collection('orders')
        .get()
        .then(data => {
          const missingPayments = []; /// payment_id available
          const missingOrderBalance = [];
          const missingOrderBalanceTest = [];
          const minimalOrderBalance = [];
          let order = '';
          data.forEach((item, i) => {
            if (item.exists) {
              order = item.data();
              if (order.site_db_id !== '-LGjZtGpLePH-61Rp662' && order.site_db_id !== '-LGjZIjpUA5jHPPUDXdj' && order.order_status.status !== 'complete') {
                if (order.payment_id !== undefined && order.payment_id !== '' && order.payments === undefined) {
                  missingPayments.push(item.id);
                }
                if (order.order_balance === undefined) {
                  missingOrderBalance.push(item.id);
                }
                if (order.order_balance_test === undefined) {
                  missingOrderBalanceTest.push(item.id);
                }
                if (order.order_balance > 0 && order.order_balance < 1) {
                  minimalOrderBalance.push(item.id);
                }
              }
            }
          });
        });
      // Get CMAG products END
      // dbFS.collection('orders').where('site_db_id', '==', clipperSiteData.firebase_id).get().then(data => {
      // // dbFS.collection('mailingLists').where('siteDbId', '==', clipperSiteData.firebase_id).get().then(data => {
      // // dbFS.collection('maps').where('siteDbId', '==', clipperSiteData.firebase_id).get().then(data => {
      // // dbFS.collection('payments').where('site_db_id', '==', clipperSiteData.firebase_id).get().then(data => {
      // 	console.log('RESULT')
      // 	console.log(data)
      //
      // 	data.forEach(doc => {
      // 		if (doc.exists) {
      // 			if (doc.data().crm_order_id > 0) {
      // 				ordersWithCrmID.push({
      // 					firebase_order_id: doc.data().firebase_order_id,
      // 					crm_order_id: doc.data().crm_order_id
      // 				})
      // 			} else {
      // 				ordersWithoutCrmID.push({
      // 					firebase_order_id: doc.data().firebase_order_id,
      // 					crm_order_id: doc.data().crm_order_id
      // 				})
      // 			}
      //
      // 			if (doc.data().product_name !== undefined && doc.data().product_name !== '') {
      // 				if (ordersByProducts[doc.data().product_name] === undefined) {
      // 					ordersByProducts[doc.data().product_name] = []
      // 				}
      // 				ordersByProducts[doc.data().product_name].push(doc.id)
      // 			}
      // // 				// if (!missingReferences.includes(doc.data().product_name)) {
      // // 				// 	missingReferences.push(doc.data().product_name)
      // // 				// }
      // // 			// 	if (!missingReferences[doc.data().product_name]) {
      // // 			// 		missingReferences[doc.data().product_name] = []
      // // 			// 	}
      // // 			// 	missingReferences[doc.data().product_name].push(doc.id)
      // // 			//
      // // 			// }
      // // 			// idList.push(doc.id)
      // 			// if (doc.data().references === undefined) {
      // 			// 	missingReferences.push(doc.id)
      // 			// } else if (doc.data().references.map_id !== '') {
      // 			// 	mapReferences.push({
      // 			// 		order_id: doc.id,
      // 			// 		map_id: doc.data().references.map_id.split('maps/')[1]
      // 			// 	})
      // 			// } else if (doc.data().references.design_id !== '') {
      // 			// 	designReferences.push({
      // 			// 		order_id: doc.id,
      // 			// 		design_id: doc.data().references.design_id.split('customDesigns/')[1]
      // 			// 	})
      // 			// } else if (doc.data().references.order_list_id !== '') {
      // 			// 	orderListReferences.push({
      // 			// 		order_id: doc.id,
      // 			// 		list_id: doc.data().references.order_list_id.split('mailingLists/')[1]
      // 			// 	})
      // 			// } else if (doc.data().references.upload_list_id !== '') {
      // 			// 	uploadListReferences.push({
      // 			// 		order_id: doc.id,
      // 			// 		list_id: doc.data().references.upload_list_id.split('mailingLists/')[1]
      // 			// 	})
      // 			// } else if (doc.data().references.later_list_id !== '') {
      // 			// 	laterListReferences.push({
      // 			// 		order_id: doc.id,
      // 			// 		list_id: doc.data().references.later_list_id.split('mailingLists/')[1]
      // 			// 	})
      // 			// }
      // 			//
      // 			// if (doc.data().payment_id !== undefined && doc.data().payment_id !== '') {
      // 			// 	paymentsList.push({
      // 			// 		order_id: doc.id,
      // 			// 		payment_id: doc.data().payment_id
      // 			// 	})
      // 			// }
      // 			// MAPS
      // 			// mapReferences.push({
      // 			// 	map_data: doc.data(),
      // 			// 	map_id: doc.id
      // 			// })
      //
      // 			// Payment
      // 			// paymentsList.push({
      // 			// 	payment_id: doc.id,
      // 			// 	payment_data: doc.data()
      // 			// })
      //
      // 			idList.push({
      // 					order_id: doc.id,
      // 					// crm_order_id: doc.data().crm_order_id
      // 				})
      //
      // 				dataList.push({
      // 					order_id: doc.id,
      // 					order_data: doc.data()
      // 				})
      //
      //
      // 			// === MAILING LIST====
      // // 			laterListReferences.push(doc.id)
      // 		}
      // 	})
      // 	console.log('isLIST:')
      // 	console.log(idList)
      // 	console.log('dataList:')
      // 	console.log(dataList)
      // 	console.log('dataList:')
      // 	console.log(dataList)
      // 	console.log('ordersByProducts:')
      // 	console.log(ordersByProducts)
      // // 	console.log('missingReferences:')
      // // 	console.log(missingReferences)
      // // 	console.log('designReferences:')
      // // 	console.log(designReferences)
      // // 	console.log('mapReferences:')
      // // 	console.log(mapReferences)
      // // 	console.log('orderListReferences:')
      // // 	console.log(orderListReferences)
      // // 	console.log('uploadListReferences:')
      // // 	console.log(uploadListReferences)
      // // 	console.log('laterListReferences:')
      // // 	console.log(laterListReferences)
      // 	console.log('ordersWithCrmID:')
      // 	console.log(ordersWithCrmID)
      // 	console.log('ordersWithoutCrmID:')
      // 	console.log(ordersWithoutCrmID)
      // 	// console.log('paymentsList:')
      // 	// console.log(paymentsList)
      // 	// console.log(mapReferences)
      // })
    },
    async convertCsvToJson() {
      // UPDATE DATA IN JSON
      // const growmailUsersFile = require('@/assets/migration/growmail_all_users.json')
      // const growmailUsers = growmailUsersFile.users
      // const campUsersFile = require('@/assets/migration/users_export_eddmexpert.json')
      // const campUsers = campUsersFile.users
      const growmailLocationsFile = require('@/assets/migration/growmail_all_locations.json');
      const growmailLocations = growmailLocationsFile.locations;
      //
      // // 1. part START - Create json which contains old and new wp ids, emails and new crm customer id between two site
      // const result = []
      // let campIdxInGrowmail = ''
      //
      // for (let i in campUsers) {
      // 	campIdxInGrowmail = growmailUsers.findIndex(item => item.email === campUsers[i].email)
      // 	if (campIdxInGrowmail > -1) {
      // 		result.push({
      // 			email: growmailUsers[campIdxInGrowmail].email,
      // 			crm_customer_id: growmailUsers[campIdxInGrowmail].crm_customer_id,
      // 			wp_user_id: growmailUsers[campIdxInGrowmail].wp_user_id,
      // 			old_wp_user_id: campUsers[i].old_wp_id
      // 		})
      // 	} else {
      // 		console.log('MISSING USER: ', campUsers[i].email)
      // 	}
      // }
      //
      // console.log('result file:' , result)
      // 1. part END

      // 2. part START - Remove new line unix from strings, change wp id and customer id to int

      // for (let i in campUsers) {
      // 	campUsers[i].old_wp_id = parseInt(campUsers[i].old_wp_id.replace('\t\t\t', ''))
      // 	campUsers[i].crm_customer_id = parseInt(campUsers[i].crm_customer_id)
      // }

      // console.log('result file:' , campUsers)
      // 2. part END

      //3. part CONVERT CSV TO JSON ------

      // const Papa = require('papaparse')
      // //TODO: Implement loading string from file, or paste the text here
      // const csvFileContent = ``
      //
      // Papa.parse(csvFileContent, {
      // 		header: true,
      // 		delimiter: ',',
      // 		skipEmptyLines: true,
      // 		complete: function(results) {
      // 				console.log('convertCsvToJson Result: ',)
      // 				console.log(results)
      //
      // 				if (results.errors) {
      // 						console.log('convertCsvToJson Failed: ',)
      // 						console.log(results)
      // 				}
      // 		}
      // })
      // 3. part END

      // 4. part START - Change string to int
      for (let i in growmailLocations) {
        growmailLocations[i].location_id = parseInt(growmailLocations[i].location_id);
        growmailLocations[i].old_location_id = parseInt(growmailLocations[i].old_location_id);
      }
      console.log('result file:', growmailLocations);
      // 4. part END
    },
    // ========== MIGRATION SCRIPT  END ==========

    addItemToOrderRoot() {
      // ACTIVE,QUOTE ORDERS - ADD order_balance, order_balance_test and payments properties
      console.log('AddItemToOrderRoot called');
      const referencePromises = [];
      const paymentPromises = [];
      const incompleteOrderIdsWithBalance = [];
      const incompleteOrderIds = [];
      const activeOrderIds = [];
      const activeOrderIdsWithBalance = [];
      const paymentTest = [];
      const missingPayment = [];
      const crmOrderIdTest = [];
      // Get orders from the DB with 'active','quote','incomplete' status
      const orderRef = dbFS.collection('orders');
      const paymentRef = dbFS.collection('payments');

      const promises = [];

      // INCOMPLETE AND QUOTE - NO PAYAMENT

      // orderRef.where('site_db_id', '==', '-M2ha7T0lS5a46o0C7Jn')
      // // .where('firebase_order_id', '==', 'orSKIvvxo42JO3yfEXF5')
      // // orderRef.where('firebase_order_id', '==', 'RCXb4stBB05eP6DNXNbC')
      // 				// .where('order_status.status', '==', 'incomplete')
      // .where('order_status.status', '==', 'quote')
      // 				.where('payment_id', '==', '')
      // 				// .limit(10)
      // 				.get().then(data => {
      // 					console.log('ORDERS: ', data)
      // 					data.forEach(doc => {
      // 						if (doc.exists) {
      // 							const orderObj = doc.data()
      //
      // 							//TEST
      // 							if (orderObj.payment_id !== '') {
      // 								paymentTest.push(doc.id)
      // 							}
      // 							if (orderObj.crm_order_id !== '' && orderObj.crm_order_id !== 0) {
      // 								crmOrderIdTest.push(doc.id)
      // 							}
      // 							// TEST END
      //
      // 							if (orderObj.order_balance === undefined) {
      // 								incompleteOrderIds.push(doc.id)
      // 								referencePromises.push(
      // 									orderRef.doc(doc.id).set({
      // 										'order_balance': -Math.abs(orderObj.order_total),
      // 										'order_balance_test': -Math.abs(orderObj.order_total)
      // 									}, { merge: true })
      // 								)
      // 							} else {
      // 								incompleteOrderIdsWithBalance.push(doc.id)
      // 							}
      // 						}
      // 					})

      // INCOMPLETE AND QUOTE - NO PAYAMENT - END
      // ACTIVE,QUOTE ORDERS - ADD order_balance, order_balance_test and payments properties
      orderRef
        .where('site_db_id', '==', '-M2ha7T0lS5a46o0C7Jn')
        // .where('firebase_order_id', '==', 'j2oGCRgXvkvW0DCfzVbO')
        // .where('order_status.status', '==', 'quote'
        .where('order_status.status', '==', 'quote')
        // .where('payment_id', '==', '')
        .get()
        .then(data => {
          console.log('ORDERS: ', data);
          data.forEach(doc => {
            if (doc.exists) {
              const orderObj = doc.data();

              if (orderObj.crm_order_id !== '' && orderObj.crm_order_id !== 0) {
                crmOrderIdTest.push(doc.id);
              }
              // TEST PAYMENT ID AVAILABILITY END

              // CALCULATE BALANCE AND SAVE order_balance, order_balance_test, payments  attributes
              if (orderObj.order_balance === undefined && orderObj.payment_id !== '') {
                activeOrderIds.push(doc.id);
                const paymentIds = [];
                // GET PAYMENT OBJECT
                referencePromises.push(
                  paymentRef
                    .where('crm_order_id', '==', orderObj.crm_order_id)
                    .orderBy('paymentTime')
                    .get()
                    .then(payments => {
                      console.log('PAYMENTS: ', payments);
                      let balance = -Math.abs(orderObj.order_total);
                      payments.forEach(payment => {
                        if (payment.exists) {
                          paymentIds.push(payment.id);

                          if (payment.data().paymentType === 'corporate') {
                            balance = 0;
                          } else if (payment.data().paymentType === 'stripe') {
                            balance = payment.data().amount !== 100 && payment.data().amount !== 50 ? parseFloat(balance.toFixed(2)) + payment.data().amount / 100 : 0;
                          }
                        }
                      });

                      console.log(`ORDER ID: ${orderObj.firebase_order_id} PaymentID: ${paymentIds} BALANCE: ${balance}`);

                      return orderRef.doc(doc.id).set(
                        {
                          order_balance: balance,
                          order_balance_test: balance,
                          payments: paymentIds
                        },
                        { merge: true }
                      );
                    })
                );
              } else {
                activeOrderIdsWithBalance.push(doc.id);
                if (orderObj.order_balance === undefined && orderObj.payment_id === '') {
                  missingPayment.push(doc.id);
                  referencePromises.push(
                    orderRef.doc(doc.id).set(
                      {
                        order_balance: -Math.abs(orderObj.order_total),
                        order_balance_test: -Math.abs(orderObj.order_total)
                      },
                      { merge: true }
                    )
                  );
                }
              }
            }
            // CALCULATE BALANCE AND SAVE order_balance, order_balance_test, payments  attributes
          });

          return Promise.all(referencePromises)
            .then(result => {
              console.log('addItemToOrderRoot DONE: ', result);
              console.log('addItemToOrderRoot DONE incompleteOrderIds: ', incompleteOrderIds);
              console.log('addItemToOrderRoot DONE incompleteOrderIdsWithBalance: ', incompleteOrderIdsWithBalance);
              console.log('addItemToOrderRoot DONE activeOrderIds: ', activeOrderIds);
              console.log('addItemToOrderRoot DONE activeOrderIdsWithBalance: ', activeOrderIdsWithBalance);
              console.log('addItemToOrderRoot DONE paymentTest: ', paymentTest);
              console.log('addItemToOrderRoot DONE crmOrderIdTest: ', crmOrderIdTest);
              console.log('addItemToOrderRoot DONE crmOrderIdTest: ', missingPayment);
            })
            .catch(error => {
              console.log('addItemToOrderRoot has failed: ', error);
              console.log('addItemToOrderRoot has failed incompleteOrderIds: ', incompleteOrderIds);
              console.log('addItemToOrderRoot has failed incompleteOrderIdsWithBalance: ', incompleteOrderIdsWithBalance);
              console.log('addItemToOrderRoot DONE activeOrderIds: ', activeOrderIds);
              console.log('addItemToOrderRoot DONE activeOrderIdsWithBalance: ', activeOrderIdsWithBalance);
              console.log('addItemToOrderRoot DONE paymentTest: ', paymentTest);
              console.log('addItemToOrderRoot DONE crmOrderIdTest: ', crmOrderIdTest);
              console.log('addItemToOrderRoot DONE crmOrderIdTest: ', missingPayment);
            });
        });
    },
    testQuotePDF() {
      const token = 'PDgVwnJAEmkr3eCkExcel';
      const passingObj = this.json;
      console.log('passingObj', passingObj);
      auth.currentUser
        .getIdToken(true)
        .then(idToken => {
          // Send token to your backend via HTTPS
          passingObj.idToken = idToken;
          this.axios({
            method: 'POST',
            url: `${process.env.VUE_APP_API_URL}quotePdfGenerator`,
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json',
              Authorization: 'bearer ' + token
            },
            data: passingObj,
            responseType: 'blob'
          }).then(response => {
            this.downloadFile(response.data, 'application/pdf', 'Quote-1.pdf');
          });
        })
        .catch(error => {
          console.log('quotePdfGenerator has failed: ', error);
        });
    },
    testAddNotification() {
      const message = 'Test message...';
      const date = Number(new Date());
      const user = this.userStore.name;
      this.$store.dispatch('notifications/addNotification', { message, date, user }).then(response => {
        if (response) {
          this.notificationAdded = true;
        }
      });
    },
    addOrder() {
      console.log('Selected site:', this.selectedSite);
      console.log('Selected env:', this.selectedEnv);
      const timestamp = new Date();
      // const timestamp = firebase.firestore.Timestamp.fromDate(new Date())
      console.log('Firebase timesampt: ', timestamp);
      if (this.selectedSite !== null && this.selectedEnv !== null) {
        var expr = this.selectedEnv;

        switch (expr) {
          case 'orders':
            console.log('Orders');
            dbFS
              .collection(this.selectedEnv)
              .add({
                is_quote: false,
                api_version: '1',
                order_type: 'eddm',
                customer_unique_id: 121345,
                crm_customer_id: 0,
                creation_date: timestamp,
                first_name: 'Kincso',
                last_name: 'Kiss',
                gatekeeper_email: '',
                order_total: 123,
                discount_total: 0,
                product_name: 'Test Product Name 12×15 Oversized EDDM',
                is_test: false,
                label: 'Test SEARCHEBLE ATTRIBUTES (by Kincso)',
                crm_order_id: 0,
                database_path: 'orders',
                order_email: 'kincsok@onebrandmarketing.com',
                mailing_service: 'eddm',
                mail_qty: 0,
                extra_qty: 0,
                print_qty: 0,
                quote_id: '',
                special_instructions: '',
                site_id: 'a-test',
                site_db_id: this.selectedSite,
                site_name: 'a-test',
                payment_id: '',
                order_status: {
                  account_tag: '',
                  account_label: '',
                  status_code: 0,
                  status_proof_front: '',
                  status_proof_back: '',
                  status_approve_url: '',
                  proof_upload_url: '',
                  tracking_number: '',
                  tracking_url: '',
                  status: 'testing'
                },
                references: {
                  map_id: '',
                  order_list_id: '',
                  upload_list_id: '',
                  later_list_id: '',
                  design_id: ''
                }
              })
              .then(data => {
                // increment notification total
                this.envType = 'order';
                this.envId = data.id;
                console.log('Add to Orders:', data.id);
              });
            break;
          case 'maps':
            console.log('Maps');
            /*
             */
            dbFS
              .collection('maps')
              .add({
                clientId: '-TEST-123-',
                creationDate: timestamp,
                csvLink: 'https://emapdata.adc4gis.com/movers.csv',
                customer: {
                  clientId: '-TEST-123-',
                  crmCustomerId: 85639,
                  email: 'kincsok@onebrandmarketing.com',
                  first_name: 'Kincso',
                  last_name: 'Kiss'
                },
                emapMode: 'TEST_Mover',
                mapImgName: 'map_1234.png',
                mapImgUrl: 'https://firebasestorage.googleapis.com/v0/b/onebrandamp.appspot.com',
                moverCounts: {
                  avg: '364',
                  chart: [],
                  hasSelections: true,
                  max: 549,
                  min: 220
                },
                name: 'Map TEST Name',
                orderType: 'newmovers',
                siteDbId: this.selectedSite,
                totalCount: 364,
                uploadedFileUrl: ''
              })
              .then(data => {
                // increment notification total
                console.log('Add to Orders:', data.id);
                this.envType = 'map';
                this.envId = data.id;
              });
            break;
          case 'lists':
            console.log('Lists');
            /*
             */
            dbFS
              .collection('mailingLists')
              .add({
                creationDate: timestamp,
                crmCustomerId: 1001,
                customer: {
                  clientId: 'test-wlos-1_3_61063',
                  crmCustomerId: 61063,
                  first_name: 'Kincso',
                  last_name: 'CH',
                  userEmail: 'kincsok@onebrandmarketing.com'
                },
                listCount: 44,
                listName: 'Test List Name(Kincso)',
                siteDbId: this.selectedSite,
                type: 'political',
                userEmail: 'kincsk@onebrandmarketing.com',
                creationDateTimestamp: timestamp,
                totalPrice: 1230,
                firebase_list_id: 'vvv123',
                adjustedFilters: {
                  filters: {
                    '2011_NEW_Congressional_District': ['02'],
                    Parties_Description: ['Republican'],
                    Voters_AgeRange: ['18 to 29'],
                    EthnicGroups_EthnicGroup1Desc: ['European'],
                    Voters_Gender: ['M'],
                    Education: ['Bach Degree - Likely'],
                    HomeOwnerRenter: ['Likely Homeowner'],
                    EstimatedIncome: ['$1,000-$14,999', '$15,000-$24,999', '$25,000-$34,999']
                  },
                  fieldset: 'minimal'
                },
                filterResult: {
                  total: 44,
                  households: 44,
                  addresses: 44,
                  streets: 43
                }
              })
              .then(data => {
                // increment notification total
                console.log('Add to Lists:', data.id);
                this.envType = 'list';
                this.envId = data.id;
              });
            break;
          case 'designs':
            console.log('Designs:', this.selectedEnv);
            /*

						 */
            dbFS
              .collection('customDesigns')
              .add({
                clientId: '-1234_TEST_3_61063',
                config: {
                  initialMode: 'Advanced',
                  preloader: {},
                  restoreProductOnReloadEnabled: true,
                  spellCheckEnabled: true,
                  userId: 3
                },
                crmCustomerId: 1001,
                crm_order_id: 100100,
                customer: {
                  clientId: '-1234_TEST_3_61063',
                  crmCustomerId: 1001,
                  first_name: 'Florin',
                  last_name: 'CH',
                  userEmail: 'florinc@onebrandmarketing.com'
                },
                customizedDesignTime: timestamp,
                fb_order_path: '5BR1235',
                proofImages: {},
                renderedData: {
                  boundsData: {},
                  hiResOutputUrls: [],
                  proofImageUrls: {},
                  returnToEditUrl: 'https://dl.onebrand.net/page/iframe/?state=1234',
                  stateId: '1111-6745-4d35-83c2-1111'
                },
                savedProduct: {
                  returnToEditUrl: 'https://dl.onebrand.net/page/iframe/?state=1234',
                  stateId: '1111-6745-4d35-83c2-1111',
                  userId: '3'
                },
                siteDbId: this.selectedSite,
                surfaces: ['test_Front_9x625_EDDM', 'test_Back_9x625_EDDM'],
                templateId: 2222,
                userEmail: 'florinc@onebrandmarketing.com'
              })
              .then(data => {
                console.log('Add to designs :', data.id);
                this.envType = 'design';
                this.envId = data.id;
              });
            break;
          default:
            console.log('NONE');
        }
      } else {
        console.log('Selection Empty');
      }
    },
    generateExcel() {
      this.generateExcell = true;
      this.axios({
        method: 'GET',
        url: `${process.env.VUE_APP_API_URL}generateCsvFromDataAxle`
      }).then(response => {
        this.generateExcell = false;
        const responseData = JSON.parse(response.data);
        if (response.data.err) {
          console.error('Error:', JSON.parse(response.data.err));
        } else {
          console.log('response:', responseData);
        }
      });
    },
    generateExcelPolitical() {
      this.generateExcellPolitical = true;
      const token = this.genTkn;
      const passingObj = this.excelFiltersPolitical;
      this.axios({
        method: 'POST',
        url: `${process.env.VUE_APP_API_URL}generateCsvFromPoliticalMail`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'bearer ' + token
        },
        data: passingObj,
        responseType: 'blob'
      }).then(response => {
        this.generateExcellPolitical = false;
        this.downloadFile(response.data, 'text/csv', 'test.csv');
      });
    },
    downloadFile(data, fileType, name) {
      let blob = new Blob([data], { type: fileType });
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = name;
      link.click();
    },
    generateMapObject() {
      const token = this.apiKey;
      const firebaseID = this.mapFirebaseId;
      const passingObj = {
        firebaseID
      };
      this.generateMapObjectProgress = true;
      this.axios({
        method: 'POST',
        url: `${process.env.VUE_APP_API_URL}getMapObjectByFirebaseId`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'bearer ' + token
        },
        data: passingObj
      })
        .then(response => {
          console.log(response);
          this.generateMapObjectProgress = false;
          if (response.data.status === 'Success') {
            this.mapObject = response.data.mapObject;
            this.mapObjectSuccess = true;
          } else if (response.data.status === 'Error') {
            this.errorMsg = response.data.message;
          }
        })
        .catch(e => {
          console.log(e);
          this.generateMapObjectProgress = false;
        });
    },
    launchCampaign() {
      // console.log(this.testDmmToolUrl)
      window.open(this.testDmmToolUrl, '_blank').focus();
      // 			this.$router.push({ path: `dmm-tool/?firestore_map_id=K83GQUBAUFi33mkIoB2u&start_date=2019-08-21&end_date=2019-09-20
      // &crm_order_id=284144&drop_num=342&crm_mail_drop_id=1234&dmm_campaign_id=110777` })
    }
  }
};
</script>
<style scoped>
.custom-radius {
  border-radius: 10px;
}
</style>
